<template>
  <Loader v-if="loader" />

  <prime-accordion class="box-operation-detail">
    <prime-accordion-tab>
      <template #header>
        <i class="pi pi-plus-circle"> </i>
        <span class="pl-1">Operazioni</span>
      </template>
      <div v-if="data.item.id">
        <span>
          <prime-button
            label="VOLTURA"
            icon="pi pi-directions"
            iconPos="right"
            class="p-button-secondary mr-3"
            @click="onVoltura($event)"
          />
        </span>

        <span>
          <prime-button
            label="CAMBIA OFFERTA"
            icon="pi pi-directions"
            iconPos="right"
            class="p-button-secondary mr-3"
            @click="onCambiaOfferta($event)"
          />
        </span>

        <span>
          <prime-button
            label="AGGIORNA CONSUMI"
            icon="pi pi-directions"
            iconPos="right"
            class="p-button-secondary mr-3"
            @click="onAggiornaConsumi($event)"
          />
        </span>

        <span>
          <prime-button
            label="AGGIUNGI VOCE FATTURA"
            icon="pi pi-directions"
            iconPos="right"
            class="p-button-secondary mr-3"
            @click="openFatturaVociDialog($event)"
          />
        </span>
      </div>
    </prime-accordion-tab>
  </prime-accordion>

  <SupplyRiepilogoSection
    v-if="data.item.id"
    :contratti-vendita="data.item.contratti?.vendita || []"
    :fatture="data.item.fatture || {}"
    :pratiche-data="praticheData"
    :supply-points="[{ id: data.item.id, type: 'pod', code: data.item.info?.code }]"
    forniture-label="Fornitura associata"
  />

  <prime-accordion
    :multiple="true"
    :activeIndex="[0]"
    @tab-open="onDetailAccordionTabOpen"
  >
    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
        <span>Anagrafica Pod</span>&nbsp;<span>{{ data.item.info.code }}</span>
      </template>

      <div v-if="data.item.id">
        <div class="formgrid grid">
          <div class="field col-12">
            <h4>{{ data.item.info.code }}</h4>
          </div>
          <div class="field col-12 md:col-4">
            <label for="data_inizio">Data Inizio</label>
            <prime-calendar
              id="data_inizio"
              v-model="dataInizio"
              :showIcon="true"
              dateFormat="dd/mm/yy"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_tensione">Tipologia Tensione</label>
            <prime-dropdown
              id="cod_type_tensione"
              v-model="data.item.info.cod_type_tensione"
              :options="data.tipiTensione"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona..."
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="consumo_annuo">Consumo Annuo</label>
            <prime-input-number
              id="consumo_annuo"
              v-model="data.item.info.consumo_annuo"
              mode="decimal"
              locale="it-IT"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="data_fine">Data Fine</label>
            <prime-calendar
              id="data_fine"
              v-model="dataFine"
              :showIcon="true"
              dateFormat="dd/mm/yy"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_residente">Tipologia Residente</label>
            <prime-dropdown
              id="cod_type_residente"
              v-model="data.item.info.cod_type_residente"
              :options="data.tipiResidente"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona..."
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="voltaggio">Voltaggio</label>
            <prime-input-number
              id="voltaggio"
              v-model="data.item.info.voltaggio"
              mode="decimal"
              locale="it-IT"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="toponimo">Toponimo</label>
            <prime-input-text
              id="toponimo"
              v-model="data.item.info.toponimo"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_uso">Tipologia Uso</label>
            <prime-dropdown
              id="cod_type_uso"
              v-model="data.item.info.cod_type_uso"
              :options="data.tipiUso"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona..."
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="potenza_impegnata">Potenza Impegnata</label>
            <prime-input-number
              id="potenza_impegnata"
              v-model="data.item.info.potenza_impegnata"
              mode="decimal"
              locale="it-IT"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="indirizzo">Indirizzo</label>
            <prime-input-text
              id="indirizzo"
              v-model="data.item.info.indirizzo"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_stima">Tipologia Stima</label>
            <prime-dropdown
              id="cod_type_stima"
              v-model="data.item.info.cod_type_stima"
              :options="data.tipiStima"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona..."
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="potenza_disponibile">Potenza Disponibile</label>
            <prime-input-number
              id="potenza_disponibile"
              v-model="data.item.info.potenza_disponibile"
              mode="decimal"
              locale="it-IT"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="civico">Civico</label>
            <prime-input-text
              id="civico"
              v-model="data.item.info.civico"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_misuratore">Tipologia Misuratore</label>
            <prime-dropdown
              id="cod_type_misuratore"
              v-model="data.item.info.cod_type_misuratore"
              :options="data.tipiMisuratore"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona..."
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_distributore">Tipologia Distributore</label>
            <prime-dropdown
              id="cod_distributore"
              v-model="data.item.info.cod_distributore"
              :options="data.distributoriEnergia"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona..."
              :filter="true"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cap">CAP</label>
            <prime-input-text
              id="cap"
              v-model="data.item.info.cap"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cluster">Cluster</label>
            <prime-input-text
              id="cluster"
              v-model="data.item.info.cluster"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="disalimentabile">Disalimentabile</label>
            <prime-dropdown
              id="disalimentabile"
              v-model="data.item.info.disalimentabile"
              :options="data.disalimentabiliBoolean"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleziona..."
              :disabled="true"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="fatturazione_solo_reale">Fatturazione solo reale</label>
            <prime-dropdown
              id="fatturazione_solo_reale"
              v-model="data.item.info.fatturazione_solo_reale"
              :options="data.booleanSelect"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleziona..."
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_comune">Comune</label>
            <prime-dropdown
              id="cod_comune"
              v-model="data.item.info.cod_comune"
              :options="data.comuni"
              optionLabel="name"
              optionValue="id"
              dataKey="id"
              placeholder="Seleziona..."
              :filter="true"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cig">CIG</label>
            <prime-input-text
              id="cig"
              v-model="data.item.info.CIG"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cup">CUP</label>
            <prime-input-text
              id="cup"
              v-model="data.item.info.CUP"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <div class="formgrid grid">
              <div class="field col-12 md:col-4">
                <label for="cod_comune">KA</label>
                <p>{{ data.item.info.KA }}</p>
              </div>
              <div class="field col-12 md:col-4">
                <label for="cod_comune">KP</label>
                <p>{{ data.item.info.KP }}</p>
              </div>
              <div class="field col-12 md:col-4">
                <label for="cod_comune">KR</label>
                <p>{{ data.item.info.KR }}</p>
              </div>
            </div>
            
          </div>
          <div class="field col-12 md:col-4 flex align-items-center">
            <label class="mr-2">Sospendibile</label>
            <Checkbox :binary="true" v-model="data.item.info.sospendibile" :disabled="!isInEdit"/>
          </div>
        </div>

        <div class="grid p-jc-end">
          <div class="col-12 text-right" v-if="!isInEdit">
            <prime-button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success mr-2"
              @click="onEditInfo"
            />
          </div>

          <div class="col-12 text-right" v-if="isInEdit">
            <prime-button
              icon="pi pi-times"
              class="p-button-rounded p-button-danger mr-2"
              @click="onAbortInfoEdit"
            />
            <prime-button
              icon="pi pi-check"
              class="p-button-rounded p-button-success mr-2"
              @click="onUpdateInfo"
            />
          </div>
        </div>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab
      v-if="hasWizardCaricamentiAccess"
      header="Caricamenti Wizard"
    >
      <div v-if="data.item.id">
        <Loader v-if="wizardCaricamentiLoading" />
        <div
          v-else-if="wizardCaricamenti.length === 0"
          class="p-3 text-600"
        >
          Nessun caricamento wizard trovato
        </div>
        <prime-data-table
          v-else
          :value="wizardCaricamenti"
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          responsiveLayout="scroll"
          showGridlines
          scrollable
        >
          <prime-column
            v-for="column of wizardCaricamentiColumns"
            :key="column"
            :field="column"
            :header="column"
            style="min-width: 180px"
          >
            <template #body="{ data: rowData }">
              <prime-button
                v-if="column === 'logs_modifiche' && hasWizardCaricamentiLogs(rowData[column])"
                label="Vedi log"
                icon="pi pi-list"
                class="p-button-sm p-button-text"
                @click="openWizardCaricamentiLogsDialog(rowData)"
              />
              <prime-button
                v-else-if="column === 'matrice_id' && rowData[column]"
                :label="String(rowData[column])"
                icon="pi pi-search"
                class="p-button-sm p-button-text"
                @click="openWizardCaricamentoMatriceDialog(rowData[column])"
              />
              <span v-else-if="column === 'logs_modifiche'"></span>
              <span v-else>
                {{ formatWizardCaricamentiValue(rowData[column]) }}
              </span>
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Storico RCU (Vecchio)">
      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.rcus"
          responsiveLayout="scroll"
          editMode="cell"
          @cell-edit-complete="onCellRcusDateEditComplete"
        >
          <prime-column field="udd" header="UDD"></prime-column>
          <prime-column field="cc" header="CC"></prime-column>
          <prime-column
            field="data_inizio"
            header="Data Inizio"
            :sortable="true"
          >
            <template #body="{ data }">
              <p class="text-primary cursor-pointer">
                {{
                  data.data_inizio !== null
                    ? moment(data.data_inizio).format("DD/MM/YYYY")
                    : ""
                }}
              </p>
            </template>
            <template #editor="{ data, field }">
              <Calendar v-model="data[field]" dateFormat="dd/mm/yy" />
            </template>
          </prime-column>
          <prime-column field="data_fine" header="Data Fine" :sortable="true">
            <template #body="{ data }">
              <p class="text-primary cursor-pointer">
                {{
                  data.data_fine !== null
                    ? moment(data.data_fine).format("DD/MM/YYYY")
                    : ""
                }}
              </p>
            </template>
            <template #editor="{ data, field }">
              <Calendar v-model="data[field]" dateFormat="dd/mm/yy" />
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="RCU DT">
  <div v-if="data.item.id">
    <prime-data-table
      :paginator="true"
      :rows="10"
      :rowsPerPageOptions="[10, 25, 50]"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
      :value="data.item.rcus_from_pratiche.dati_dt"
      responsiveLayout="scroll"
    >
      <prime-column field="CODICE_POD" header="POD"></prime-column>
      <prime-column field="Area_Rif" header="Area"></prime-column>
      <prime-column field="Stato_Pod" header="Stato"></prime-column>
      <prime-column field="Tensione" header="Tensione"></prime-column>
      <prime-column field="Disalimentabilita" header="Disalimentabilità"></prime-column>
      <prime-column field="Tipo_Misuratore" header="Tipo Misuratore"></prime-column>
      <prime-column field="Potcontrimp" header="Potenza Impegnata"></prime-column>
      <prime-column field="Potdisp" header="Potenza Disponibile"></prime-column>
      <prime-column field="Consumo" header="Consumo"></prime-column>
      <prime-column field="MESE" header="Mese" :sortable="true">
        <template #body="{ data }">
          {{ data.MESE ? moment(data.MESE).format("DD/MM/YYYY") : "" }}
        </template>
      </prime-column>
    </prime-data-table>
  </div>
</prime-accordion-tab>

<prime-accordion-tab header="RCU DF">
  <div v-if="data.item.id">
    <prime-data-table
      :paginator="true"
      :rows="10"
      :rowsPerPageOptions="[10, 25, 50]"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
      :value="data.item.rcus_from_pratiche.dati_df"
      responsiveLayout="scroll"
    >
      <prime-column field="Ragione_Sociale_Distr" header="Distributore"></prime-column>
      <prime-column field="Ragione_Sociale_Udd" header="UDD"></prime-column>
      <prime-column field="Ragione_Sociale_Cc" header="CC"></prime-column>
      <prime-column field="Data_Inizio_Fornitura" header="Data Inizio" :sortable="true">
        <template #body="{ data }">
          {{ data.Data_Inizio_Fornitura ? moment(data.Data_Inizio_Fornitura).format("DD/MM/YYYY") : "" }}
        </template>
      </prime-column>
      <prime-column field="Data_Fine_Fornitura" header="Data Fine">
        <template #body="{ data }">
          {{ data.Data_Fine_Fornitura ? moment(data.Data_Fine_Fornitura).format("DD/MM/YYYY") : "" }}
        </template>
      </prime-column>
      <prime-column field="Tariffa_Distribuzione" header="Tariffa"></prime-column>
      <prime-column field="Residenza" header="Residenza"></prime-column>
      <prime-column field="Mese" header="Mese" :sortable="true">
        <template #body="{ data }">
          {{ data.Mese ? moment(data.Mese).format("DD/MM/YYYY") : "" }}
        </template>
      </prime-column>
    </prime-data-table>
  </div>
</prime-accordion-tab>

<prime-accordion-tab header="RCU IND">
  <div v-if="data.item.id">
    <prime-data-table
      :paginator="true"
      :rows="10"
      :rowsPerPageOptions="[10, 25, 50]"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
      :value="data.item.rcus_from_pratiche.dati_ind"
      responsiveLayout="scroll"
    >
      <prime-column field="Toponimo_Forn" header="Toponimo"></prime-column>
      <prime-column field="Via_Forn" header="Via"></prime-column>
      <prime-column field="Civ_Forn" header="Civico"></prime-column>
      <prime-column field="Cap_Forn" header="CAP"></prime-column>
      <prime-column field="Localita_Forn" header="Località"></prime-column>
      <prime-column field="Prov_Forn" header="Provincia"></prime-column>
      <prime-column field="Mese" header="Mese" :sortable="true">
        <template #body="{ data }">
          {{ data.Mese ? moment(data.Mese).format("DD/MM/YYYY") : "" }}
        </template>
      </prime-column>
    </prime-data-table>
  </div>
</prime-accordion-tab>

    <prime-accordion-tab header="Storico Contratti Acquisto">
      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.contratti.acquisto"
          responsiveLayout="scroll"
        >
          <prime-column field="ragsoc" header="Fornitore"></prime-column>
          <prime-column field="data_inizio" header="Data Inizio">
            <template #body="{ data }">
              {{
                data.data_inizio !== null
                  ? moment(data.data_inizio).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
          <prime-column field="data_fine" header="Data Fine">
            <template #body="{ data }">
              {{
                data.data_fine !== null
                  ? moment(data.data_fine).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Storico Contratti Vendita">
      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.contratti.vendita"
          responsiveLayout="scroll"
          editMode="cell"
          @cell-edit-init="onCellContrattoVenditaEditInit"
        >
          <!-- <prime-column field="ragsoc" header="Fornitore" ></prime-column> -->
          <prime-column header="Contratto">
            <template #body="{ data }">
              <router-link
                :to="`/ask/contratti/vendita/${data.c_id}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="`${data.code}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
            </template>
          </prime-column>

          <prime-column header="Cliente">
            <template #body="{ data }">
              <router-link
                :to="`/ask/clienti/${data.cod_cliente}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="`${data.cliente}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
            </template>
          </prime-column>

          <prime-column header="Fornitori">
            <template #body="{ data }">
              <router-link
                :to="`/ask/fornitori/${data.cod_reseller}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="`${data.reseller}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
            </template>
          </prime-column>

          <prime-column header="Offerta">
            <template #body="{ data }">
              <router-link
                :to="`/ask/offerte/listini/${data.cod_offerta}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="`${data.offerta}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
            </template>
          </prime-column>

          <prime-column header="Data Firma">
            <template #body="{ data }">
              {{
                data.data_firma !== null
                  ? moment(data.data_firma).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
          <prime-column header="Data Inizio">
            <template #body="{ data }">
              {{
                data.data_inizio !== null
                  ? moment(data.data_inizio).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
          <prime-column field="data_fine" header="Data Fine">
            <template #body="{ data }">
              <p
                v-if="isContrattoVenditaDataFineEditable(data)"
                class="text-primary cursor-pointer m-0"
              >
                {{ formatContrattoVenditaDataFine(data) }}
              </p>
              <span v-else>{{ formatContrattoVenditaDataFine(data) }}</span>
            </template>
            <template #editor="{ data, editorCancelCallback }">
              <div
                v-if="isContrattoVenditaDataFineEditable(data)"
                class="flex align-items-center gap-2"
                @click.stop
              >
                <prime-calendar
                  v-model="data._editDataFine"
                  dateFormat="dd/mm/yy"
                  :showIcon="true"
                  appendTo="body"
                />
                <prime-button
                  icon="pi pi-check"
                  class="p-button-rounded p-button-success"
                  @click="confirmContrattoVenditaDataFine(data, editorCancelCallback)"
                />
                <prime-button
                  icon="pi pi-times"
                  class="p-button-rounded p-button-text"
                  @click="editorCancelCallback"
                />
              </div>
              <span v-else>{{ formatContrattoVenditaDataFine(data) }}</span>
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Pratiche">
      <SupplyPraticheSection
        v-if="data.item.id"
        :pratiche-data="praticheData"
        :auto-fetch="false"
      />
    </prime-accordion-tab>

    <prime-accordion-tab header="Pre Check">
      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.pre_checks"
          responsiveLayout="scroll"
        >
          <prime-column field="ragsoc" header="Fornitore"></prime-column>
          <prime-column field="data" header="Data Esito">
            <template #body="{ data }">
              {{
                data.data !== null ? moment(data.data).format("DD/MM/YYYY") : ""
              }}
            </template>
          </prime-column>
          <prime-column field="esito" header="Esito">
            <template #body="{ data }">
              {{ data.esito ? "POSITIVO" : "NEGATIVO" }}
            </template>
          </prime-column>
          <prime-column field="causale" header="Causale"></prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="RCU">
      <div class="field col-12 md:col-3">
        <prime-button label="RCU" />
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Letture">
      <div>
        <Button
          label="Crea Lettura"
          icon="pi pi-plus"
          class="p-button-success"
          @click="router.replace({ 
            path: '/AutoLettura', 
            query: { 
              pod: data.item.info.code, 
              cod_pod: data.item.id, 
              create: 'true',
              ultima_lettura: JSON.stringify({
                eaf1: data.item?.letture?.[0]?.eaf1 ?? 0,
                eaf2: data.item?.letture?.[0]?.eaf2 ?? 0,
                eaf3: data.item?.letture?.[0]?.eaf3 ?? 0,
                erf1: data.item?.letture?.[0]?.erf1 ?? 0,
                erf2: data.item?.letture?.[0]?.erf2 ?? 0,
                erf3: data.item?.letture?.[0]?.erf3 ?? 0,
                pf1: data.item?.letture?.[0]?.pf1 ?? 0,
                pf2: data.item?.letture?.[0]?.pf2 ?? 0,
                pf3: data.item?.letture?.[0]?.pf3 ?? 0,
                KR: data.item?.info?.KR ?? 0,
                KA: data.item?.info?.KA ?? 0,
                KP: data.item?.info?.KP ?? 0
               
              })
            } 
          })"
        />

        <Button
          label="Vedi tutte le letture"
          icon="pi pi-eye"
          iconPos="right"
          class="mb-2 ml-2"
          @click="viewAllLetture"
        />

        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.letture"
          responsiveLayout="scroll"
          editMode="row"
          @row-edit-save="onRowEditLetturaComplete"
          v-model:editingRows="editingRowsLetture"
        >
          <prime-column field="data" header="Data Comunicazione">
            <template #body="{ data }">
              {{
                data.data_comunicazione !== null
                  ? moment(data.data_comunicazione).format("DD/MM/YYYY HH:MM")
                  : ""
              }}
            </template>
          </prime-column>
          <prime-column
            field="data"
            header="Periodo (ultimo gg)"
            style="min-width: 130px"
          >
            <template #body="{ data }">
              {{
                data.data_misura !== null
                  ? moment(data.data_misura)
                      .locale("it")
                      .format("MMMM YYYY")
                      .toUpperCase()
                  : ""
              }}
            </template>
          </prime-column>

          <prime-column field="eaf1" header="F1" :sortable="true">
            <template #editor="{ data }">
              <InputText v-model="data.eaf1" />
            </template>
            <template #body="{ data }">
              {{ data.eaf1 !== null ? data.eaf1 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="F2">
            <template #editor="{ data }">
              <InputText v-model="data.eaf2" />
            </template>
            <template #body="{ data }">
              {{ data.eaf2 !== null ? data.eaf2 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="F3">
            <template #editor="{ data }">
              <InputText v-model="data.eaf3" />
            </template>
            <template #body="{ data }">
              {{ data.eaf3 !== null ? data.eaf3 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="Energia">
            <template #body="{ data }">
              {{ (data.eaf1 + data.eaf2 + data.eaf3).toFixed(2) }}
            </template>
          </prime-column>

          <prime-column header="F1 R">
            <template #editor="{ data }">
              <InputText v-model="data.erf1" />
            </template>
            <template #body="{ data }">
              {{ data.erf1 !== null ? data.erf1 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="F2 R">
            <template #editor="{ data }">
              <InputText v-model="data.erf2" />
            </template>
            <template #body="{ data }">
              {{ data.erf2 !== null ? data.erf2 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="F3 R">
            <template #editor="{ data }">
              <InputText v-model="data.erf3" />
            </template>
            <template #body="{ data }">
              {{ data.erf3 !== null ? data.erf3 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="Energia R">
            <template #body="{ data }">
              {{ (data.erf1 + data.erf2 + data.erf3).toFixed(2) }}
            </template>
          </prime-column>

          <prime-column header="Pot F1">
            <template #editor="{ data }">
              <InputText v-model="data.pf1" />
            </template>
            <template #body="{ data }">
              {{ data.pf1 !== null ? data.pf1 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="Pot F2">
            <template #editor="{ data }">
              <InputText v-model="data.pf2" />
            </template>
            <template #body="{ data }">
              {{ data.pf2 !== null ? data.pf2 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="Pot F3">
            <template #editor="{ data }">
              <InputText v-model="data.pf3" />
            </template>
            <template #body="{ data }">
              {{ data.pf3 !== null ? data.pf3 : 0.0 }}
            </template>
          </prime-column>

          <prime-column header="Usato" style="text-align: center">
            <template #body="{ data }">
              <i v-if="data.used" class="pi pi-check" />
              <i v-else class="pi pi-times" />
            </template>
          </prime-column>
          <prime-column header="Data Comunicazione">
            <template #body="{ data }">
              {{ data.data_comunicazione !== null
                  ? moment(data.data_comunicazione).format("DD/MM/YYYY")
                  : "" }}
            </template>
          </prime-column>
          <prime-column header="Autolettura">
            <template #body="{ data }">
              {{ data.autolettura ? "SI" : "NO" }}
            </template>
          </prime-column>
          <prime-column field="tipolettura" header="Tipolettura" />
          <prime-column field="validato" header="Validato" />

          <prime-column :exportable="false" style="text-align: center">
            <template #body="{ data: lettura }">
              <prime-button
                v-show="lettura.used"
                title="Riusa"
                icon="pi pi-directions-alt"
                iconPos="right"
                class="p-button-info m-1"
                @click="onRiusaLettura(this.route.params.id, lettura.id)"
              />
              <prime-button
                v-show="!lettura.used"
                title="Elimina"
                icon="pi pi-trash"
                iconPos="right"
                class="p-button-danger m-1"
                @click="onDeleteLettura(this.route.params.id, lettura.id)"
              />
            </template>
          </prime-column>
          <prime-column
            :rowEditor="true"
            style="width: 10%; min-width: 8rem"
            bodyStyle="text-align:center"
          >
            <template #body="{ data }">
              <prime-button
                v-if="data.used === 0 && data.autolettura === 1"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success"
                @click="onRowEditInit(data)"
              />
            </template>
            <template #editor="{ data }">
              <div class="flex justify-content-center">
                <prime-button
                  icon="pi pi-check"
                  class="p-button-rounded p-button-success mr-2"
                  @click="onRowEditLetturaComplete({ data, newData: data })"
                />
                <prime-button
                  icon="pi pi-times"
                  class="p-button-rounded p-button-danger"
                  @click="onRowEditCancel"
                />
              </div>
            </template>
          </prime-column>
          <prime-column
            header="Storico"
            :exportable="false"
            style="width: 4rem; text-align: center"
            bodyStyle="text-align:center"
          >
            <template #body="{ data: lettura }">
              <prime-button
                v-if="hasAutoletturaId(lettura)"
                title="Storico autolettura"
                icon="pi pi-clock"
                class="p-button-rounded p-button-help"
                @click.stop="openStoricoAutoletturaDialog(lettura)"
              />
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Altre Voci in Fattura">
      <div v-if="data.item.id">
        <prime-button
          label="AGGIUNGI VOCE"
          icon="pi pi-plus"
          class="p-button-secondary mb-3"
          @click="openFatturaVociDialog"
        />

        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.fatture.altre_voci"
          responsiveLayout="scroll"
        >
          <prime-column field="c_desc" header="Descrizione"></prime-column>
          <prime-column field="descrizione" header="Note"></prime-column>
          <prime-column header="Data">
            <template #body="{ data }">
              {{
                data.mese !== null ? moment(data.mese).format("DD/MM/YYYY") : ""
              }}
            </template>
          </prime-column>
          <prime-column header="Importo">
            <template #body="{ data }">
              {{
                currencyFormatter.format(
                  data.importo !== null ? data.importo : 0
                )
              }}
            </template>
          </prime-column>
          <prime-column header="Aliquota">
            <template #body="{ data }">
              {{ data.aliquota !== null ? `${data.aliquota}%` : "0%" }}
            </template>
          </prime-column>
          <prime-column header="Usato" style="text-align: center">
            <template #body="{ data }">
              <i v-if="data.used" class="pi pi-check" />
              <i v-else class="pi pi-times" />
            </template>
          </prime-column>
          <prime-column style="text-align: center">
            <template #body="{ data }">
              <prime-button
                v-if="!data.used"
                icon="pi pi-trash"
                class="p-button-rounded p-button-danger m-2"
                @click="onDeleteFatturaVoce(data)"
              />
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Mensilit&agrave; reali">
      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.mesilita_reali"
          responsiveLayout="scroll"
        >
          <prime-column field="datas" header="Data Creazione">
            <template #body="{ data }">
              {{
                data.datas !== null ? moment(data.datas).format("DD/MM/YYYY") : ""
              }}
            </template>
          </prime-column>

          <prime-column field="data" header="Data Comunicazione">
            <template #body="{ data }">
              {{
                data.data !== null ? moment(data.data).format("DD/MM/YYYY") : ""
              }}
            </template>
          </prime-column>

          <prime-column header="F1">
            <template #body="{ data }">
              {{ data.eaf1 !== null ? data.eaf1 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="F2">
            <template #body="{ data }">
              {{ data.eaf2 !== null ? data.eaf2 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="F3">
            <template #body="{ data }">
              {{ data.eaf3 !== null ? data.eaf3 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="Energia">
            <template #body="{ data }">
              {{
                (
                  parseFloat(data.eaf1) +
                  parseFloat(data.eaf2) +
                  parseFloat(data.eaf3)
                ).toFixed(2)
              }}
            </template>
          </prime-column>

          <prime-column header="F1 R">
            <template #body="{ data }">
              {{ data.erf1 !== null ? data.erf1 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="F2 R">
            <template #body="{ data }">
              {{ data.erf2 !== null ? data.erf2 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="F3 R">
            <template #body="{ data }">
              {{ data.erf3 !== null ? data.erf3 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="Energia R">
            <template #body="{ data }">
              {{
                (
                  parseFloat(data.erf1) +
                  parseFloat(data.erf2) +
                  parseFloat(data.erf3)
                ).toFixed(2)
              }}
            </template>
          </prime-column>

          <prime-column header="Pot F1">
            <template #body="{ data }">
              {{ data.pf1 !== null ? data.pf1 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="Pot F2">
            <template #body="{ data }">
              {{ data.pf2 !== null ? data.pf2 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="Pot F3">
            <template #body="{ data }">
              {{ data.pf3 !== null ? data.pf3 : 0.0 }}
            </template>
          </prime-column>

          <prime-column header="Usato" style="text-align: center">
            <template #body="{ data }">
              <i v-if="data.used" class="pi pi-check" />
              <i v-else class="pi pi-times" />
            </template>
          </prime-column>
          <prime-column field="used_ft" header="Fattura"></prime-column>

          <prime-column :exportable="false">
            <template #body="{ data }">
              <!-- <prime-button
                v-if="!data.used"
                icon="pi pi-trash"
                class="p-button-rounded p-button-danger"
                @click="onDeleteMensilitaReale(this.route.params.id, data.id)"
              /> -->
              <Button
                v-if="!data.used"
                icon="pi pi-exclamation-circle"
                class="p-button-rounded p-button-warning ml-2"
                @click="onMensilitaRealeUsed2(this.route.params.id, data.id)"
                v-tooltip.top="'Marca come Used 2'"
              />
              <Button
                v-if="canRiusaMensilitaReale(data)"
                icon="pi pi-replay"
                class="p-button-rounded p-button-info ml-2"
                :disabled="isRiusaMensilitaRealeDisabled(data)"
                @click="onRiusaMensilitaReale(this.route.params.id, data.id)"
                v-tooltip.top="'Riusa'"
              />
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Consumi Distributore">
      <div v-if="data.item.id">
        <prime-button
          label="AGGIUNGI CONSUMO"
          icon="pi pi-plus"
          class="p-button-secondary mb-3"
          @click="openConsumoDialog"
        />

        <prime-data-table
          :key="consumiKey"
          :value="consumi"
          editMode="row"
          v-model:editingRows="editingRowsConsumo"
          @row-edit-init="onRowEditInit"
          @row-edit-save="onRowEditSave"
          @row-edit-cancel="onRowEditCancel"
          responsiveLayout="scroll"
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} consumi"
        >
          <!-- Colonna per la data di comunicazione -->
          <prime-column field="data_comunicazione" header="Data Comunicazione">
            <template #body="{ data }">
              {{ data.data_comunicazione }}
            </template>
          </prime-column>

          <!-- Colonna per la data di misura -->
          <prime-column field="data_misura" header="Data Misura">
            <template #body="{ data }">
              {{ data.data_misura }}
            </template>
          </prime-column>

          <!-- Colonne per i valori EAF -->
          <prime-column field="eaf1" header="EAF1">
            <template #editor="{ data, field }">
              <InputText v-model="data[field]" />
            </template>
          </prime-column>

          <prime-column field="eaf2" header="EAF2">
            <template #editor="{ data, field }">
              <InputText v-model="data[field]" />
            </template>
          </prime-column>

          <prime-column field="eaf3" header="EAF3">
            <template #editor="{ data, field }">
              <InputText v-model="data[field]" />
            </template>
          </prime-column>

          <!-- Colonne per i valori ERF -->
          <prime-column field="erf1" header="ERF1">
            <template #editor="{ data, field }">
              <InputText v-model="data[field]" />
            </template>
          </prime-column>

          <prime-column field="erf2" header="ERF2">
            <template #editor="{ data, field }">
              <InputText v-model="data[field]" />
            </template>
          </prime-column>

          <prime-column field="erf3" header="ERF3">
            <template #editor="{ data, field }">
              <InputText v-model="data[field]" />
            </template>
          </prime-column>

          <!-- Colonne per le potenze PF -->
          <prime-column field="pf1" header="PF1">
            <template #editor="{ data, field }">
              <InputText v-model="data[field]" />
            </template>
          </prime-column>

          <prime-column field="pf2" header="PF2">
            <template #editor="{ data, field }">
              <InputText v-model="data[field]" />
            </template>
          </prime-column>

          <prime-column field="pf3" header="PF3">
            <template #editor="{ data, field }">
              <InputText v-model="data[field]" />
            </template>
          </prime-column>
          <prime-column field="type" header="Tipo"></prime-column>
          <prime-column field="validato" header="Validato"></prime-column>
          <prime-column field="autolettura" header="Autolettura">
            <template #body="{ data }">
              {{ data.autolettura ? "SI" : "NO" }}
            </template>
          </prime-column>
          <!-- <prime-column :rowEditor="true" style="width: 10%; min-width: 8rem" />
          <prime-column :rowEditor="true" style="width: 10%; min-width: 8rem">
            <template #body="{ data }">
              <prime-button
                icon="pi pi-trash"
                class="p-button-rounded p-button-danger p-mr-2"
                @click="onDeleteConsumo(data.id)"
              />
              <prime-row-editor />
            </template>
          </prime-column> -->
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Mensilit&agrave; Fatturabile">
      <div v-if="data.item.id">
        <p class="mensilita-edit-hint">
          <i class="pi pi-pencil"></i>
          Clicca su <strong>Data inizio</strong> o <strong>Data fine</strong> per modificarle.
        </p>
        <prime-data-table
          :key="mensilitaFatturabiliKey"
          ref="dtMensilitaFatturabili"
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.mensilita_fatturabili"
          dataKey="id"
          responsiveLayout="scroll"
          editMode="cell"
          @cell-edit-init="onMensilitaFatturabileCellEditInit"
        >
          <prime-column header="Mese">
            <template #body="{ data }">
              {{
                data.mese !== null
                  ? moment(data.mese)
                      .locale("it")
                      .format("MMMM YYYY")
                      .toUpperCase()
                  : ""
              }}
            </template>
          </prime-column>
          <prime-column field="ragsoc" header="CC"></prime-column>
          <prime-column field="inizio" header="Data Inizio" sortable>
            <template #editor="slotProps">
              <div class="p-d-flex p-ai-center">
                <Calendar 
                  v-model="slotProps.data.inizio" 
                  dateFormat="yy-mm-dd" 
                  showIcon 
                  :minDate="getFirstDayOfMonth(slotProps.data.inizio)"
                  :maxDate="getLastDayOfMonth(slotProps.data.inizio)"
                  @date-select="onDateSelect($event, slotProps.data, 'inizio')" 
                />
                <Button 
                  icon="pi pi-check" 
                  class="p-button-rounded p-button-success p-ml-2" 
                  @click="confirmEdit(slotProps.data, 'inizio', slotProps.editorCancelCallback)" 
                />
              </div>
            </template>
            <template #body="slotProps">
              <span class="editable-date-cell" title="Clicca per modificare">
                {{ formatDate(slotProps.data.inizio) }}
                <i class="pi pi-pencil"></i>
              </span>
            </template>
          </prime-column>
          
          <prime-column field="fine" header="Data Fine" sortable>
            <template #editor="slotProps">
              <div class="p-d-flex p-ai-center">
                <Calendar 
                  v-model="slotProps.data.fine" 
                  dateFormat="yy-mm-dd" 
                  showIcon 
                  :minDate="getFirstDayOfMonth(slotProps.data.fine)"
                  :maxDate="getLastDayOfMonth(slotProps.data.fine)"
                  @date-select="onDateSelect($event, slotProps.data, 'fine')" 
                />
                <Button 
                  icon="pi pi-check" 
                  class="p-button-rounded p-button-success p-ml-2" 
                  @click="confirmEdit(slotProps.data, 'fine', slotProps.editorCancelCallback)" 
                />
              </div>
            </template>
            <template #body="slotProps">
              <span class="editable-date-cell" title="Clicca per modificare">
                {{ formatDate(slotProps.data.fine) }}
                <i class="pi pi-pencil"></i>
              </span>
            </template>
          </prime-column>
          <prime-column header="Richiesta Conguaglio" style="min-width: 170px">
            <template #body="{ data }">
              <div class="p-d-flex p-ai-center">
                <RadioButton
                  :inputId="'rapid-check-pod-' + data.id"
                  :name="'rapid-check-pod-' + data.id"
                  :modelValue="isRapidChecked(data) ? 1 : 0"
                  :value="1"
                  :disabled="isRapidChecked(data) || rapidCheckLoadingId === data.id"
                  @click.stop="onRapidCheck(data)"
                />
                <small v-if="isRapidChecked(data) && data.data_rapidCheck" class="p-ml-2">
                  {{ formatRapidCheckDate(data.data_rapidCheck) }}
                </small>
              </div>
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Entrate - Uscite">
      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.saldi"
          responsiveLayout="scroll"
        >
          <prime-column header="Mese">
            <template #body="{ data }">
              {{
                data.data_inizio !== null
                  ? moment(data.data_inizio)
                      .locale("it")
                      .format("MMMM YYYY")
                      .toUpperCase()
                  : ""
              }}
            </template>
          </prime-column>
          <prime-column header="Data Inizio">
            <template #body="{ data }">
              {{
                data.data_inizio !== null
                  ? moment(data.data_inizio).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
          <prime-column header="Data Fine">
            <template #body="{ data }">
              {{
                data.data_fine !== null
                  ? moment(data.data_fine).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
          <prime-column header="Acquisto">
            <template #body="{ data }">
              {{
                currencyFormatter.format(
                  data.totale_fatturato !== null ? data.totale_fatturato : 0
                )
              }}
            </template>
          </prime-column>
          <prime-column header="Vendita">
            <template #body="{ data }">
              {{
                currencyFormatter.format(data.uscite !== null ? data.uscite : 0)
              }}
            </template>
          </prime-column>
          <prime-column header="Saldo">
            <template #body="{ data }">
              {{
                currencyFormatter.format(data.totale_fatturato - data.uscite)
              }}
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Consumi da ASK Flussi">
      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.rcus_from_flussi"
          responsiveLayout="scroll"
        >
          <prime-column field="data" header="Data Inizio">
            <template #body="{ data }">
              {{
                data.period.start_date !== null
                  ? moment(data.period.start_date).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
          <prime-column field="data" header="Data Fine">
            <template #body="{ data }">
              {{
                data.period.stop_date !== null
                  ? moment(data.period.stop_date).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>

          <prime-column header="F1">
            <template #body="{ data }">
              {{ data.ea_f1 !== null ? data.ea_f1 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="F2">
            <template #body="{ data }">
              {{ data.ea_f2 !== null ? data.ea_f2 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="F3">
            <template #body="{ data }">
              {{ data.ea_f3 !== null ? data.ea_f3 : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="Energia">
            <template #body="{ data }">
              {{ data.ea_total !== null ? data.ea_total : 0.0 }}
            </template>
          </prime-column>
          <prime-column header="Potenza Massima">
            <template #body="{ data }">
              {{ data.pow_max !== null ? data.pow_max : 0.0 }}
            </template>
          </prime-column>

          <prime-column header="Rettifica">
            <template #body="{ data }">
              {{ data.is_correction ? "SI" : "NO" }}
            </template>
          </prime-column>
          <prime-column header="Stimato">
            <template #body="{ data }">
              {{ data.is_estimation ? "SI" : "NO" }}
            </template>
          </prime-column>
          <prime-column header="Da dettagli">
            <template #body="{ data }">
              {{ data.from_details ? "SI" : "NO" }}
            </template>
          </prime-column>

          <prime-column field="data" header="Data Comunicazione">
            <template #body="{ data }">
              {{
                data.period.created_at !== null
                  ? moment(data.period.created_at).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Fatture Fornitori - Dettaglio POD">
      <prime-accordion>
        <prime-accordion-tab
          v-for="(fornitori, company) in data.item.dettagli_fatture_fornitori"
          :key="company"
          :header="company.toUpperCase()"
        >
          <prime-accordion>
            <prime-accordion-tab
              v-for="(dettaglio, fornitore) in fornitori"
              :key="fornitore"
              :header="fornitore.toUpperCase()"
            >
              <prime-data-table
                :ref="`${fornitore}-data-table`"
                :value="fornitori[fornitore]"
                v-model:expandedRows="
                  data.fattureFornitori.expandedRows[fornitore]
                "
                dataKey="id"
                responsiveLayout="scroll"
              >
                <prime-column :expander="true" headerStyle="width: 3rem" />

                <prime-column
                  field="fattura"
                  header="Numero Frattura"
                ></prime-column>
                <prime-column header="Mese">
                  <template #body="{ data }">
                    {{
                      data.mese !== null
                        ? moment(data.mese)
                            .locale("it")
                            .format("MMMM YYYY")
                            .toUpperCase()
                        : ""
                    }}
                  </template>
                </prime-column>

                <template #expansion="{ data }">
                  <div class="provider-invoice-detail-subtable">
                    <h5>Dettagli fattura N° {{ data.fattura }}</h5>

                    <prime-data-table
                      :value="data.dettagli"
                      responsiveLayout="scroll"
                    >
                      <prime-column header="Dal">
                        <template #body="{ data }">
                          {{
                            data.dal !== null
                              ? moment(data.dal).format("DD/MM/YYYY")
                              : ""
                          }}
                        </template>
                      </prime-column>
                      <prime-column header="Al">
                        <template #body="{ data }">
                          {{
                            data.al !== null
                              ? moment(data.al).format("DD/MM/YYYY")
                              : ""
                          }}
                        </template>
                      </prime-column>
                      <prime-column
                        field="componente"
                        header="Componente"
                      ></prime-column>
                      <prime-column
                        field="quantita"
                        header="Quantita"
                      ></prime-column>
                      <prime-column header="Importo">
                        <template #body="{ data }">
                          {{
                            currencyFormatter.format(
                              data.importo !== null ? data.importo : 0
                            )
                          }}
                        </template>
                      </prime-column>
                    </prime-data-table>
                  </div>
                </template>
              </prime-data-table>
            </prime-accordion-tab>
          </prime-accordion>
        </prime-accordion-tab>
      </prime-accordion>
    </prime-accordion-tab>

    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
        <span>Fatture</span>&nbsp;<span
          >Totale:&nbsp;{{
            currencyFormatter.format(data.item.fatture.importo_totale)
          }}&nbsp;Da pagare:&nbsp;{{
            currencyFormatter.format(
              data.item.fatture.importo_totale -
                data.item.fatture.importo_pagato
            )
          }}</span
        >
      </template>

      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="fatture_ordinate"
          :rowClass="fatturaRowClass"
          responsiveLayout="scroll"
        >
          <prime-column header="Numero">
            <template #body="{ data }">
              <router-link
                :to="`/ask/clienti/fatture/${data.numero}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="`${data.numero}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
            </template>
          </prime-column>
          <prime-column header="Stato">
            <template #body="{ data }">
              <Tag
                v-if="!isFatturaDaPagare(data)"
                severity="success"
                value="Pagata"
              />
              <Tag
                v-else-if="Number(data.pagato || 0) > 0"
                severity="warning"
                value="Pagata in parte"
              />
              <Tag v-else severity="danger" value="Da pagare" />
            </template>
          </prime-column>
          <prime-column header="Importo Fattura">
            <template #body="{ data }">
              {{
                currencyFormatter.format(
                  data.importo !== null ? data.importo : 0
                )
              }}
            </template>
          </prime-column>
          <prime-column header="Importo Pagato">
            <template #body="{ data }">
              {{
                currencyFormatter.format(
                  data.pagato !== null ? data.pagato : 0
                )
              }}
            </template>
          </prime-column>
          <prime-column header="Da Pagare">
            <template #body="{ data }">
              {{ currencyFormatter.format(residuoFattura(data)) }}
            </template>
          </prime-column>
          <prime-column field="data" header="Data Scadenza">
            <template #body="{ data }">
              {{
                data.data_scadenza !== null
                  ? moment(data.data_scadenza).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>
  </prime-accordion>

  <prime-accordion
    v-if="data.item.id"
    class="preview-fattura-accordion"
  >
    <prime-accordion-tab>
      <template #header>
        <span class="preview-fattura-accordion__title">
          <i class="pi pi-file-invoice preview-fattura-accordion__icon"></i>
          Preview Fattura
        </span>
      </template>
      <div>
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.preview_fattura || []"
          responsiveLayout="scroll"
        >
          <prime-column field="p_code" header="POD"></prime-column>

          <prime-column header="Contratto">
            <template #body="{ data }">
              <router-link
                v-if="data.cod_contratto"
                :to="`/ask/contratti/vendita/${data.cod_contratto}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="data.contratto || `${data.cod_contratto}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
              <span v-else>{{ data.contratto || "" }}</span>
            </template>
          </prime-column>

          <prime-column header="Cliente">
            <template #body="{ data }">
              <router-link
                v-if="data.cod_cliente"
                :to="`/ask/clienti/${data.cod_cliente}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="data.cliente || `${data.cod_cliente}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
              <span v-else>{{ data.cliente || "" }}</span>
            </template>
          </prime-column>

          <prime-column header="Mese Fatturazione">
            <template #body="{ data }">
              {{
                data.mese_fatturazione !== null
                  ? moment(data.mese_fatturazione)
                      .locale("it")
                      .format("MMMM YYYY")
                      .toUpperCase()
                  : ""
              }}
            </template>
          </prime-column>

          <prime-column header="Inizio Mese Fatturazione">
            <template #body="{ data }">
              {{
                data.inizio_mese_fatturazione !== null
                  ? moment(data.inizio_mese_fatturazione).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>

          <prime-column header="Fine Mese Fatturazione">
            <template #body="{ data }">
              {{
                data.fine_mese_fatturazione !== null
                  ? moment(data.fine_mese_fatturazione).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>

          <prime-column header="Imponibile">
            <template #body="{ data }">
              {{
                currencyFormatter.format(
                  data.imponibile !== null ? data.imponibile : 0
                )
              }}
            </template>
          </prime-column>

          <prime-column header="Totale Fattura">
            <template #body="{ data }">
              {{
                currencyFormatter.format(
                  data.totale_fattura !== null ? data.totale_fattura : 0
                )
              }}
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>
  </prime-accordion>

  <!-- Dialog add fattura voce -->
  <Dialog
    v-model:visible="fatturaVociDialog"
    :style="{ width: '90%' }"
    header="Aggiungi voce"
    :modal="true"
  >
    <div class="grid">
      <div class="field col-12 md:col-4">
        <label>Voce</label>
        <Dropdown
          v-model="newFatturavoce.voce"
          :options="fatturaVoci"
          optionLabel="descrizione"
          optionValue="id"
          dataKey="id"
          placeholder="Seleziona"
          :filter="true"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.voce && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.voce && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>Importo</label>
        <InputText
          type="number"
          v-model="newFatturavoce.importo"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.importo && submitted },
          ]"
          :value="newFatturavoce.importo"
        />
        <small class="p-error" v-if="validationErrors.importo && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>Aliquota</label>
        <InputText
          v-model="newFatturavoce.aliquota"
          :minFractionDigits="2"
          :maxFractionDigits="2"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.aliquota && submitted },
          ]"
          :value="newFatturavoce.aliquota"
        />
        <small class="p-error" v-if="validationErrors.aliquota && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>Descrizione</label>
        <InputText
          v-model="newFatturavoce.descrizione"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.descrizione && submitted },
          ]"
          :value="newFatturavoce.descrizione"
        />
        <small class="p-error" v-if="validationErrors.descrizione && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>Periodo</label>
        <Calendar
          v-model="newFatturavoce.periodo"
          :showIcon="true"
          selectionMode="range"
          view="month"
          dateFormat="mm-yy"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.periodo && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.periodo && submitted"
          >Campo richiesto</small
        >
      </div>
    </div>

    <div class="report" v-if="reportInsertFatturaVoci.length">
      <prime-data-table
        :paginator="true"
        :rows="10"
        :rowsPerPageOptions="[10, 25, 50]"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
        :value="reportInsertFatturaVoci"
        responsiveLayout="scroll"
      >
        <prime-column field="month" header="Mese"></prime-column>
        <prime-column field="msg" header="Messaggio"></prime-column>
        <prime-column field="success" header="Esito">
          <template #body="slotProps">
            <i v-if="slotProps.data.success" class="pi pi-check"></i>
            <i v-else class="pi pi-times"></i>
          </template>
        </prime-column>
      </prime-data-table>
    </div>

    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="fatturaVociDialog = false"
      />
      <Button
        label="Salva"
        :disabled="reportInsertFatturaVoci.length > 0"
        icon="pi pi-check"
        class="p-button-text"
        @click="addVoceInFattura"
      />
    </template>
  </Dialog>

  <!-- Dialog add new lettura -->
  <Dialog
    v-model:visible="letturaNewDialog"
    :style="{ width: '90%' }"
    header="Crea lettura"
    :modal="true"
  >
    <div class="grid">
      <div class="field col-12 md:col-12">
        <label>Data</label>
        <Calendar
          v-model="letturaNew.data"
          view="month"
          :manualInput="false"
          dateFormat="mm-yy"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12 md:col-4">
        <label>EAF1</label>
        <InputText
          type="number"
          v-model="letturaNew.eaf1"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.eaf1 && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.eaf1 && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>EAF2</label>
        <InputText
          type="number"
          v-model="letturaNew.eaf2"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.eaf2 && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.eaf2 && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>EAF3</label>
        <InputText
          type="number"
          v-model="letturaNew.eaf3"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.eaf3 && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.eaf3 && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>ERF1</label>
        <InputText
          type="number"
          v-model="letturaNew.erf1"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.erf1 && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.erf1 && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>ERF2</label>
        <InputText
          type="number"
          v-model="letturaNew.erf2"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.erf2 && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.erf2 && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>ERF3</label>
        <InputText
          type="number"
          v-model="letturaNew.erf3"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.erf3 && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.erf3 && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>PF1</label>
        <InputText
          type="number"
          v-model="letturaNew.pf1"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.pf1 && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.pf1 && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>PF2</label>
        <InputText
          type="number"
          v-model="letturaNew.pf2"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.pf2 && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.pf2 && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>PF3</label>
        <InputText
          type="number"
          v-model="letturaNew.pf3"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.pf3 && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.pf3 && submitted"
          >Campo richiesto</small
        >
      </div>
    </div>

    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="letturaNewDialog = false"
      />
      <Button
        label="Crea"
        icon="pi pi-check"
        class="p-button-text"
        @click="addNewLettura"
      />
    </template>
  </Dialog>

  <!-- Dialog all letture -->
  <Dialog
    v-model:visible="allLettureDialog"
    :style="{ width: '90%' }"
    header="Tutte le letture"
    :modal="true"
  >
    <div>
      <prime-data-table
        ref="all_letture"
        dataKey="id"
        :paginator="true"
        :rows="10"
        :rowsPerPageOptions="[10, 25, 50]"
        paginatorTemplate="FirstPageLink PrevPageLi+nk PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
        :value="allLetture"
        responsiveLayout="scroll"
      >
        <template #header>
          <div class="flex justify-content-end flex-wrap">
            <div class="flex align-items-center justify-content-center">
              <Button
                icon="pi pi-external-link"
                label="Esporta"
                @click="exportCSV($event)"
                class="p-button-secondary"
              />
            </div>
          </div>
        </template>
        <template #empty>
          <div class="text-center">Nessun dato trovato.</div>
        </template>
        <prime-column
          field="data_misura"
          header="Data Misura"
          style="min-width: 130px"
        >
          <template #body="{ data }">
            {{
              data.data_misura !== null
                ? moment(data.data_misura)
                    .locale("it")
                    .format("DD-MM-YYYY")
                    .toUpperCase()
                : ""
            }}
          </template>
        </prime-column>

        <prime-column field="eaf1" header="F1" :sortable="true">
          <template #body="{ data }">
            {{ data.eaf1 !== null ? data.eaf1 : 0.0 }}
          </template>
        </prime-column>
        <prime-column field="eaf2" header="F2">
          <template #body="{ data }">
            {{ data.eaf2 !== null ? data.eaf2 : 0.0 }}
          </template>
        </prime-column>
        <prime-column field="eaf3" header="F3">
          <template #body="{ data }">
            {{ data.eaf3 !== null ? data.eaf3 : 0.0 }}
          </template>
        </prime-column>
        <prime-column header="Energia">
          <template #body="{ data }">
            {{ (data.eaf1 + data.eaf2 + data.eaf3).toFixed(2) }}
          </template>
        </prime-column>

        <prime-column field="erf1" header="F1 R">
          <template #body="{ data }">
            {{ data.erf1 !== null ? data.erf1 : 0.0 }}
          </template>
        </prime-column>
        <prime-column field="erf2" header="F2 R">
          <template #body="{ data }">
            {{ data.erf2 !== null ? data.erf2 : 0.0 }}
          </template>
        </prime-column>
        <prime-column field="erf3" header="F3 R">
          <template #body="{ data }">
            {{ data.erf3 !== null ? data.erf3 : 0.0 }}
          </template>
        </prime-column>
        <prime-column header="Energia R">
          <template #body="{ data }">
            {{ (data.erf1 + data.erf2 + data.erf3).toFixed(2) }}
          </template>
        </prime-column>

        <prime-column field="pf1" header="Pot F1">
          <template #body="{ data }">
            {{ data.pf1 !== null ? data.pf1 : 0.0 }}
          </template>
        </prime-column>
        <prime-column field="pf2" header="Pot F2">
          <template #body="{ data }">
            {{ data.pf2 !== null ? data.pf2 : 0.0 }}
          </template>
        </prime-column>
        <prime-column field="pf3" header="Pot F3">
          <template #body="{ data }">
            {{ data.pf3 !== null ? data.pf3 : 0.0 }}
          </template>
        </prime-column>

        <prime-column field="used" header="Usato" style="text-align: center">
          <template #body="{ data }">
            <i v-if="data.used" class="pi pi-check" />
            <i v-else class="pi pi-times" />
          </template>
        </prime-column>
        <prime-column field="autolettura" header="Autolettura">
          <template #body="{ data }">
            {{ data.autolettura ? "SI" : "NO" }}
          </template>
        </prime-column>
        <prime-column field="type" header="Tipo" />
        <prime-column field="tipolettura" header="TipoLettura" />
        <prime-column field="validato" header="Validato" />
        <prime-column field="file" header="file" />
      </prime-data-table>
    </div>

    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="allLettureDialog = false"
      />
    </template>
  </Dialog>

  <Dialog
    v-model:visible="storicoAutoletturaDialog"
    :style="{ width: '540px' }"
    header="Storico autolettura"
    :modal="true"
    appendTo="body"
    class="storico-autolettura-dialog"
  >
    <div v-if="storicoAutoletturaLoading" class="storico-autolettura-state">
      <ProgressSpinner style="width: 40px; height: 40px" />
      <p>Caricamento storico...</p>
    </div>
    <div v-else-if="storicoAutoletturaError" class="storico-autolettura-alert">
      <i class="pi pi-exclamation-triangle" />
      <span>{{ storicoAutoletturaError }}</span>
    </div>
    <div v-else-if="storicoAutoletturaView.hasData" class="storico-autolettura-content">
      <section v-if="storicoAutoletturaView.valori.length" class="storico-section">
        <h4 class="storico-section-title">
          <i class="pi pi-chart-bar" />
          Valori
        </h4>
        <div class="storico-values-grid">
          <div
            v-for="item in storicoAutoletturaView.valori"
            :key="item.key"
            class="storico-value-card"
          >
            <span class="storico-value-label">{{ item.label }}</span>
            <span class="storico-value-number">{{ item.value }}</span>
          </div>
        </div>
      </section>

      <section v-if="storicoAutoletturaView.date.length" class="storico-section">
        <h4 class="storico-section-title">
          <i class="pi pi-calendar" />
          Date
        </h4>
        <div class="storico-info-list">
          <div
            v-for="item in storicoAutoletturaView.date"
            :key="item.key"
            class="storico-info-row"
          >
            <span class="storico-info-label">{{ item.label }}</span>
            <span class="storico-info-value">{{ item.value }}</span>
          </div>
        </div>
      </section>

      <section v-if="storicoAutoletturaView.utente.length" class="storico-section">
        <h4 class="storico-section-title">
          <i class="pi pi-user" />
          Utente
        </h4>
        <div class="storico-info-list">
          <div
            v-for="item in storicoAutoletturaView.utente"
            :key="item.key"
            class="storico-info-row"
          >
            <span class="storico-info-label">{{ item.label }}</span>
            <span
              class="storico-info-value"
              :class="{
                'storico-info-value--external': item.tone === 'external',
                'storico-info-value--internal': item.tone === 'internal',
              }"
            >{{ item.value }}</span>
          </div>
        </div>
      </section>

      <section class="storico-section">
        <h4 class="storico-section-title">
          <i class="pi pi-check-circle" />
          Conferma
        </h4>
        <div class="storico-info-list">
          <div
            v-for="item in storicoAutoletturaView.conferma"
            :key="item.key"
            class="storico-info-row"
          >
            <span class="storico-info-label">{{ item.label }}</span>
            <span
              class="storico-info-value"
              :class="{
                'storico-info-value--internal': item.tone === 'internal',
                'storico-info-value--system': item.tone === 'system',
              }"
            >{{ item.value }}</span>
          </div>
        </div>
      </section>
    </div>
    <div v-else class="storico-autolettura-state storico-autolettura-state--empty">
      <i class="pi pi-inbox" />
      <p>Nessun dato disponibile</p>
    </div>
    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="closeStoricoAutoletturaDialog"
      />
    </template>
  </Dialog>

  <Dialog
    v-model:visible="wizardCaricamentiLogsDialog"
    :style="{ width: '90%' }"
    header="Log modifiche caricamento wizard"
    :modal="true"
    :closable="true"
  >
    <div v-if="wizardCaricamentiLogsDialogRow" class="mb-3">
      <strong>Riga selezionata:</strong>
      {{ getWizardCaricamentiDialogTitle(wizardCaricamentiLogsDialogRow) }}
    </div>

    <div
      v-if="wizardCaricamentiLogs.length === 0"
      class="p-3 text-600"
    >
      Nessun log modifica disponibile
    </div>
    <prime-data-table
      v-else
      :value="wizardCaricamentiLogs"
      responsiveLayout="scroll"
      showGridlines
      scrollable
    >
      <prime-column field="id" header="ID Log" style="min-width: 110px">
        <template #body="{ data }">
          {{ data.id || "-" }}
        </template>
      </prime-column>
      <prime-column field="function" header="Function" style="min-width: 180px">
        <template #body="{ data }">
          {{ data.function || "-" }}
        </template>
      </prime-column>
      <prime-column field="data_inserimento" header="Data Inserimento" style="min-width: 180px">
        <template #body="{ data }">
          {{ formatWizardLogDate(data.data_inserimento) }}
        </template>
      </prime-column>
      <prime-column field="name_table" header="Tabella" style="min-width: 180px">
        <template #body="{ data }">
          {{ data.name_table || "-" }}
        </template>
      </prime-column>
      <prime-column field="id_record" header="ID Record" style="min-width: 120px">
        <template #body="{ data }">
          {{ data.id_record || "-" }}
        </template>
      </prime-column>
      <prime-column field="id_user" header="ID Utente" style="min-width: 120px">
        <template #body="{ data }">
          {{ data.id_user || "-" }}
        </template>
      </prime-column>
      <prime-column field="data_prev" header="Stato Precedente" style="min-width: 320px">
        <template #body="{ data }">
          <pre class="wizard-log-json">{{ formatWizardLogJson(data.data_prev) }}</pre>
        </template>
      </prime-column>
      <prime-column field="data_next" header="Stato Successivo" style="min-width: 320px">
        <template #body="{ data }">
          <pre class="wizard-log-json">{{ formatWizardLogJson(data.data_next) }}</pre>
        </template>
      </prime-column>
    </prime-data-table>

    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="wizardCaricamentiLogsDialog = false"
      />
    </template>
  </Dialog>

  <Dialog
    v-model:visible="wizardCaricamentoMatriceDialog"
    :style="{ width: '70%' }"
    header="Dettaglio caricamento multisito"
    :modal="true"
    :closable="true"
  >
    <div v-if="wizardCaricamentoMatriceId" class="mb-3">
      <strong>Matrice ID:</strong> {{ wizardCaricamentoMatriceId }}
    </div>

    <Loader v-if="wizardCaricamentoMatriceLoading" />
    <div
      v-else-if="wizardCaricamentoMatriceRows.length === 0"
      class="p-3 text-600"
    >
      Nessun dettaglio disponibile
    </div>
    <prime-data-table
      v-else
      :value="wizardCaricamentoMatriceRows"
      responsiveLayout="scroll"
      showGridlines
      scrollable
    >
      <prime-column field="field" header="Campo" style="min-width: 220px" />
      <prime-column field="value" header="Valore" style="min-width: 420px">
        <template #body="{ data }">
          <pre class="wizard-log-json">{{ data.value }}</pre>
        </template>
      </prime-column>
    </prime-data-table>

    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="wizardCaricamentoMatriceDialog = false"
      />
    </template>
  </Dialog>

  <Dialog
    v-model:visible="consumoDialog"
    :style="{ width: '50%' }"
    header="Aggiungi Consumo"
    :modal="true"
    :closable="true"
  >
    <div class="grid">
      <div class="field col-12">
        <label for="data_comunicazione">Data Comunicazione</label>
        <Calendar
          id="data_comunicazione"
          v-model="newConsumo.data_comunicazione"
          :showIcon="true"
          dateFormat="mm-yy"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12">
        <label for="data_misura">Periodo Misura</label>
        <Calendar
          id="data_misura"
          v-model="newConsumo.data_misura"
          :showIcon="true"
          dateFormat="mm-yy"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12">
        <label for="eaf1">EAF1</label>
        <InputText
          id="eaf1"
          type="number"
          v-model="newConsumo.eaf1"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12">
        <label for="eaf2">EAF2</label>
        <InputText
          id="eaf2"
          type="number"
          v-model="newConsumo.eaf2"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12">
        <label for="eaf3">EAF3</label>
        <InputText
          id="eaf3"
          type="number"
          v-model="newConsumo.eaf3"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12">
        <label for="pf1">PF1</label>
        <InputText
          id="pf1"
          type="number"
          v-model="newConsumo.pf1"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12">
        <label for="pf2">PF2</label>
        <InputText
          id="pf2"
          type="number"
          v-model="newConsumo.pf2"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12">
        <label for="pf3">PF3</label>
        <InputText
          id="pf3"
          type="number"
          v-model="newConsumo.pf3"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12">
        <label for="erf1">ERF1</label>
        <InputText
          id="erf1"
          type="number"
          v-model="newConsumo.erf1"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12">
        <label for="erf2">ERF2</label>
        <InputText
          id="erf2"
          type="number"
          v-model="newConsumo.erf2"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12">
        <label for="erf3">ERF3</label>
        <InputText
          id="erf3"
          type="number"
          v-model="newConsumo.erf3"
          class="inputfield w-full"
        />
      </div>
    </div>

    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="consumoDialog = false"
      />
      <Button
        label="Salva"
        icon="pi pi-check"
        class="p-button-text"
        @click="addConsumo"
      />
    </template>
  </Dialog>
</template>

<script>
import UtilityService from "@/services/ask-management/utility-service";
import PodsService from "@/services/ask-management/pods-service";
import AutoLetturaService from "@/services/ask-management/autolettura";
import Loader from "@/components/Loader.vue";
import SupplyPraticheSection from "@/components/ask/details/SupplyPraticheSection.vue";
import SupplyRiepilogoSection from "@/components/ask/details/SupplyRiepilogoSection.vue";
import PrimeButton from "primevue/button";
import PrimeAccordion from "primevue/accordion";
import PrimeAccordionTab from "primevue/accordiontab";
import PrimeDataTable from "primevue/datatable";
import PrimeColumn from "primevue/column";
import PrimeCalendar from "primevue/calendar";
import PrimeDropdown from "primevue/dropdown";
import PrimeInputNumber from "primevue/inputnumber";
import PrimeInputText from "primevue/inputtext";
import moment from "moment";
import { useRouter } from 'vue-router';
import { useStore } from "vuex";

export default {
  name: "ViewAskPodsDetail",

  components: {
    Loader,
    SupplyPraticheSection,
    SupplyRiepilogoSection,
    PrimeButton,
    PrimeAccordion,
    PrimeAccordionTab,
    PrimeDataTable,
    PrimeColumn,
    PrimeCalendar,
    PrimeDropdown,
    PrimeInputNumber,
    PrimeInputText,
  },

  data() {
    return {
      moment,
      loader: false,
      riusandoMensilitaIds: [],
      submitted: false,
      validationErrors: {},
      currencyFormatter: new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
      }),
      route: {
        params: null,
      },
      isInEdit: false,
      oldInfo: null,
      fatturaVociDialog: false,
      fatturaVoci: [],
      newFatturavoce: {},
      reportInsertFatturaVoci: [],
      editingRowsLetture: [],
      letturaNewDialog: false,
      no_sospensione: false,
      letturaNew: {
        data: new Date(),
        eaf1: 0,
        eaf2: 0,
        eaf3: 0,
        erf1: 0,
        erf2: 0,
        erf3: 0,
        pf1: 0,
        pf2: 0,
        pf3: 0,
      },
      allLettureDialog: false,
      allLetture: [],
      storicoAutoletturaDialog: false,
      storicoAutoletturaLoading: false,
      storicoAutoletturaError: null,
      storicoAutoletturaData: null,
      consumoDialog: false,
      wizardCaricamenti: [],
      wizardCaricamentiColumns: [],
      wizardCaricamentiLoading: false,
      wizardCaricamentiLoadedForCode: null,
      wizardCaricamentiLogsDialog: false,
      wizardCaricamentiLogsDialogRow: null,
      wizardCaricamentiLogs: [],
      wizardCaricamentoMatriceDialog: false,
      wizardCaricamentoMatriceLoading: false,
      wizardCaricamentoMatriceId: null,
      wizardCaricamentoMatriceRows: [],
      editingRowsConsumo: [],
      consumiKey: 0,
      newConsumo: {
        data_comunicazione: null,
        data_misura: null,
        eaf1: 0,
        eaf2: 0,
        eaf3: 0,
        erf1: 0,
        erf2: 0,
        erf3: 0,
        pf1: 0,
        pf2: 0,
        pf3: 0,
        type: "C",
      },
      data: {
        fattureFornitori: {
          expandedRows: [],
        },
        allegato: {
          path: null,
          tipo: null,
          note: null,
        },
        booleanSelect: [
          { label: "NO", value: 0 },
          { label: "SI", value: 1 },
        ],
        disalimentabiliBoolean: [
          { label: "NO", value: "N" },
          { label: "SI", value: "Y" },
        ],
        comuni: [],
        distributoriEnergia: [],
        tipiAllegato: [],
        tipiMisuratore: [],
        tipiStima: [],
        tipiTensione: [],
        tipiResidente: [],
        tipiUso: [],
        item: {},
      },
      mensilitaFatturabili: [],
      mensilitaFatturabiliKey: 0,
      praticheData: null,
      lastEditTimestamp: 0,
      isConfirmingEdit: false,
      rapidCheckLoadingId: null,
    };
  },

  created() {
    this.route.params = this.$route.params;
    this.podsService = new PodsService(this.$http, this.$eventBus);
    this.autoLetturaService = new AutoLetturaService(this.$eventBus);
    this.utilityService = new UtilityService(this.$http, this.$eventBus);
    this.getDettaglioPod(this.route.params.id);
    this.getComuni();
    this.getDistributoriEnergia();
    this.getTipiAllegato();
    this.getTipiStima();
    this.getTipiTensione();
    this.getTipiResidente();
    this.getTipiUso();
    this.getTipiMisuratore();
    this.getFatturaVoci();
    this.getConsumo(this.route.params.id);
  },
  methods: {
    onDetailAccordionTabOpen(evt) {
      if (evt.index === 1) {
        this.loadWizardCaricamentiByCode();
      }
    },

    getPodCode() {
      return String(this.data?.item?.info?.code || "").trim();
    },

    extractWizardCaricamentiColumns(items) {
      const columns = new Set();

      items.forEach((item) => {
        if (item && typeof item === "object" && !Array.isArray(item)) {
          Object.keys(item).forEach((key) => columns.add(key));
        }
      });

      const orderedColumns = Array.from(columns);
      const logsColumnIndex = orderedColumns.indexOf("logs_modifiche");

      if (logsColumnIndex > 0) {
        orderedColumns.splice(logsColumnIndex, 1);
        orderedColumns.unshift("logs_modifiche");
      }

      return orderedColumns;
    },

    formatWizardCaricamentiValue(value) {
      if (value === null || typeof value === "undefined") {
        return "";
      }

      if (typeof value === "object") {
        return JSON.stringify(value);
      }

      return value;
    },

    hasWizardCaricamentiLogs(logs) {
      return Array.isArray(logs) && logs.length > 0;
    },

    parseWizardLogJson(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return null;
      }

      if (typeof value === "object") {
        return value;
      }

      try {
        return JSON.parse(value);
      } catch (error) {
        return value;
      }
    },

    formatWizardLogJson(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return "";
      }

      if (typeof value === "string") {
        return value;
      }

      return JSON.stringify(value, null, 2);
    },

    formatWizardLogDate(value) {
      if (!value) {
        return "";
      }

      return moment(value).format("DD/MM/YYYY HH:mm");
    },

    getWizardCaricamentiDialogTitle(rowData) {
      return (
        rowData?.id ||
        rowData?.code ||
        rowData?.pod_code ||
        rowData?.codice_pod ||
        rowData?.codice ||
        "-"
      );
    },

    extractWizardCaricamentoMatriceRows(item) {
      if (!item || typeof item !== "object" || Array.isArray(item)) {
        return [];
      }

      return Object.entries(item).map(([field, value]) => ({
        field,
        value: this.formatWizardLogJson(this.parseWizardLogJson(value)),
      }));
    },

    openWizardCaricamentiLogsDialog(rowData) {
      const logs = Array.isArray(rowData?.logs_modifiche)
        ? rowData.logs_modifiche
        : [];

      this.wizardCaricamentiLogsDialogRow = rowData;
      this.wizardCaricamentiLogs = logs.map((log, index) => ({
        ...log,
        _index: index + 1,
        data_prev: this.parseWizardLogJson(log?.data_prev),
        data_next: this.parseWizardLogJson(log?.data_next),
      }));
      this.wizardCaricamentiLogsDialog = true;
    },

    async openWizardCaricamentoMatriceDialog(matriceId) {
      if (!matriceId) {
        return;
      }

      this.wizardCaricamentoMatriceDialog = true;
      this.wizardCaricamentoMatriceLoading = true;
      this.wizardCaricamentoMatriceId = matriceId;
      this.wizardCaricamentoMatriceRows = [];

      try {
        const result = await this.utilityService.getCaricamentoWizardByMatriceId(
          matriceId
        );
        this.wizardCaricamentoMatriceRows =
          this.extractWizardCaricamentoMatriceRows(result?.item);
      } finally {
        this.wizardCaricamentoMatriceLoading = false;
      }
    },

    async loadWizardCaricamentiByCode() {
      const code = this.getPodCode();

      if (!code || this.wizardCaricamentiLoading) {
        return;
      }

      if (this.wizardCaricamentiLoadedForCode === code) {
        return;
      }

      this.wizardCaricamentiLoading = true;

      try {
        const result = await this.podsService.getCaricamentiWizardByCode(code);
        this.wizardCaricamenti = Array.isArray(result?.items)
          ? result.items
          : [];
        this.wizardCaricamentiColumns = this.extractWizardCaricamentiColumns(
          this.wizardCaricamenti
        );
        this.wizardCaricamentiLoadedForCode = code;
      } finally {
        this.wizardCaricamentiLoading = false;
      }
    },

    navigateToTab(href) {
      window.open(href, "_blank");
    },

    residuoFattura(fattura) {
      return Number(fattura.importo || 0) - Number(fattura.pagato || 0);
    },

    isFatturaDaPagare(fattura) {
      return this.residuoFattura(fattura) > 0.005;
    },

    fatturaRowClass(fattura) {
      return this.isFatturaDaPagare(fattura) ? "fattura-da-pagare" : null;
    },

    onRowEditInit(data) {
      this.editingRowsLetture = [data];
    },

    onRowEditCancel() {
      this.editingRowsLetture = [];
    },

    onRowEditSave(event) {
      const { index, newData } = event;

      this.loader = true;
      this.podsService
        .updateConsumo(newData)
        .then((res) => {
          if (res.item) {
            this.data.item.letture = [
              ...this.data.item.letture.slice(0, index),
              { ...newData },
              ...this.data.item.letture.slice(index + 1),
            ];

            this.getConsumo(this.route.params.id);

            this.editingRowsConsumo[index] = false;
            this.$forceUpdate();

            this.$toast.add({
              severity: "success",
              summary: "Successo",
              detail: "Consumo modificato correttamente",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Errore",
              detail: "Errore durante il salvataggio del consumo",
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    onRowEditConsumoComplete(evt) {
      let { data, newData } = evt;

      this.loader = true;
      if (data.used == 0 && data.autolettura == 1) {
        this.podsService
          .updateConsumo(newData)
          .then((res) => {
            if (res.item) {
              this.getConsumo(this.route.params.id);
              this.$toast.add({
                severity: "info",
                summary: "Successo",
                detail: "Consumo modificato",
                life: 3000,
              });
            }
          })
          .finally(() => {
            this.loader = false;
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Info",
          detail: "Consumo non modificabile",
          life: 3000,
        });
      }
    },

    onDeleteConsumo(consumoId) {
      this.loader = true;

      this.podsService
        .deleteConsumo(this.route.params.id, consumoId)
        .then((res) => {
          if (res.success) {
            this.getConsumo(this.route.params.id);
            this.$toast.add({
              severity: "success",
              summary: "Successo",
              detail: "Consumo eliminato",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Errore",
              detail: "Errore durante l'eliminazione",
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    async loadPraticheFornitori(id) {
      try {
        const result = await this.podsService.getPraticheFornitori(id);
        const data = result?.item || {};

        this.praticheData = {
          fornitori: data.fornitori || [],
          pratiche: data.pratiche || [],
          pratiche_gestione: data.pratiche_gestione || [],
        };
      } catch (error) {
        console.error(error);
        this.praticheData = {
          fornitori: [],
          pratiche: [],
          pratiche_gestione: [],
        };
      }
    },

    async getDettaglioPod(id) {
      this.loader = true;
      this.praticheData = null;
      try {
        const res = await this.podsService.getDettaglioPod(id);
        this.data.item = res.item;
        this.data.item.info.sospendibile = Boolean(this.data.item.info.sospendibile)
        
        document.title =
          "info" in this.data.item
            ? "code" in this.data.item.info
              ? document.title + " - " + this.data.item.info.code
              : document.title
            : document.title;
        this.loadPraticheFornitori(res.item.id);
        this.data.item.rcus_from_pratiche = [];
        this.podsService
          .getDatiRcuEnergia(res.item.id)
          .then((result) => {
            this.data.item.rcus_from_pratiche = {
              dati_dt: result.dati_dt,
              dati_df: result.dati_df,
              dati_ind: result.dati_ind
            };
          });
        this.data.item.rcus_from_flussi = [];
        this.podsService
          .getRcusFromFlussi(res.item.info.code)
          .then((result) => {
            this.data.item.rcus_from_flussi = result.items;
          });
        this.data.item.dettagli_fatture_fornitori = [];
        this.podsService
          .getDettagliFattureFornitori(res.item.info.code)
          .then((result) => {
            const newItem = {};
            for (const [company, c] of Object.entries(result.item)) {
              newItem[company] = {};
              for (const [fornitore, f] of Object.entries(c)) {
                newItem[company][fornitore] = {};
                const fatture = [];
                f.map((el) => {
                  const index = fatture.findIndex(
                    (ell) => el.fattura == ell.fattura
                  );
                  if (index == -1) {
                    fatture.push({
                      id: el.id,
                      fattura: el.fattura,
                      mese:
                        el.dal !== null
                          ? moment(el.dal).startOf("month").format("YYYY-MM-DD")
                          : null,
                      dettagli: [el],
                    });
                  } else {
                    fatture[index].dettagli.push(el);
                  }
                });
                newItem[company][fornitore] = fatture
                  .sort(
                    (a, b) =>
                      moment(a.mese).valueOf() - moment(b.mese).valueOf()
                  )
                  .reverse();
              }
            }
            this.data.item.dettagli_fatture_fornitori = newItem;
          });
      } catch (error) {
        console.error(error);
      } finally {
        this.loader = false;
      }
    },

    getLetture() {
      this.loader = true;
      this.podsService
        .getLetture(this.route.params.id)
        .then((res) => {
          this.data.item.letture = res.items;
        })
        .finally(() => {
          this.loader = false;
        });
    },

    async getMensilitaReali() {
      if (this.data.item.id) {
        const res = await this.podsService.getMensilitaReali(this.data.item.id);
        this.mensilitaReali = res.items.filter(item => item.used === 0 || item.used === 1);
        this.totalMensilitaReali = this.mensilitaReali.length;
      }
    },

    getComuni() {
      this.utilityService.getComuni().then((res) => {
        this.data.comuni = res.items;
      });
    },

    getDistributoriEnergia() {
      this.utilityService.getDistributoriEnergia().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });
        this.data.distributoriEnergia = res.items;
      });
    },

    getTipiAllegato() {
      this.utilityService.getTipiAllegato().then((res) => {
        this.data.tipiAllegato = res.items;
      });
    },

    getTipiMisuratore() {
      this.utilityService.getTipiMisuratore().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });
        this.data.tipiMisuratore = res.items;
      });
    },

    getFatturaVoci() {
      this.utilityService.getFatturaVoci().then((res) => {
        this.fatturaVoci = res.items.data;
      });
    },

    addVoceInFattura() {
      this.loader = true;
      this.reportInsertFatturaVoci = [];
      this.submitted = true;
      if (this.validateFormFatturaVoce()) {
        let obj = JSON.parse(JSON.stringify(this.newFatturavoce));
        obj.fornitura_id = this.data.item.id;
        obj.periodo[0] = moment(this.newFatturavoce.periodo[0]).format(
          "DD-MM-YYYY"
        );
        obj.periodo[1] =
          this.newFatturavoce.periodo[1] != null
            ? moment(this.newFatturavoce.periodo[1]).format("DD-MM-YYYY")
            : moment(this.newFatturavoce.periodo[0]).format("DD-MM-YYYY");   
        this.utilityService
          .addVoceInFattura([obj], "ee")
          .then((res) => {
            this.reportInsertFatturaVoci = res.items;
            this.getDettaglioPod(this.data.item.id);
          })
          .finally(() => {
            this.loader = false;
          });
      }
    },

    addNewLettura() {
      this.loader = true;
      this.submitted = true;
      if (this.validateNewLettura()) {
        let obj = JSON.parse(JSON.stringify(this.letturaNew));
        obj.data = moment(obj.data).format("YYYY-MM-DD");
        obj.fornitura_code = this.data.item.info.code;
        this.podsService
          .addNewLettura(obj)
          .then((res) => {
            if (res.item) {
              this.letturaNewDialog = false;
              this.getLetture();
              this.$toast.add({
                severity: "info",
                summary: "Successo",
                detail: "Lettura caricata",
                life: 3000,
              });
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Errore",
                detail: "Errore caricamento",
                life: 3000,
              });
            }
          })
          .finally(() => {
            this.loader = false;
          });
      }
    },

    getTipiStima() {
      this.utilityService.getTipiStima().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });
        this.data.tipiStima = res.items;
      });
    },

    getTipiTensione() {
      this.utilityService.getTipiTensione().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });
        this.data.tipiTensione = res.items;
      });
    },

    getTipiResidente() {
      this.utilityService.getTipiResidente().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });
        this.data.tipiResidente = res.items;
      });
    },

    getTipiUso() {
      this.utilityService.getTipiUso().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });
        this.data.tipiUso = res.items;
      });
    },

    onAllegatiUpload() {
      this.$toast.add({
        severity: "info",
        summary: "Success",
        detail: "Caricato allegato",
        life: 3000,
      });
    },

    onEditInfo() {
      this.oldInfo = JSON.stringify(this.data.item.info);
      this.isInEdit = !this.isInEdit;
    },

    onAbortInfoEdit() {
      this.data.item.info = JSON.parse(this.oldInfo);
      this.oldInfo = null;
      this.isInEdit = !this.isInEdit;
    },

    onUpdateInfo() {
      const allowed = [
        "toponimo",
        "indirizzo",
        "civico",
        "cap",
        "fatturazione_solo_reale",
        "potenza_impegnata",
        "potenza_disponibile",
        "consumo_annuo",
        "voltaggio",
        "cluster",
        "cod_comune",
        "cod_type_tensione",
        "cod_type_residente",
        "cod_type_uso",
        "cod_distributore",
        "cod_fornitore_switch",
        "cod_type_misuratore",
        "cod_type_potenza",
        "cod_type_state",
        "cod_type_stima",
        'sospendibile',
        'CIG',
        'CUP'
      ];
      const info = Object.keys(this.data.item.info)
        .filter((key) => allowed.includes(key))
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: this.data.item.info[key],
          };
        }, {});
      if (info.cod_comune == -1) {
        info.cod_comune = null;
      }
      if (info.cod_type_uso == -1) {
        info.cod_type_uso = null;
      }
      if (info.cod_type_tensione == -1) {
        info.cod_type_tensione = null;
      }
      if (info.cod_type_residente == -1) {
        info.cod_type_residente = null;
      }
      if (info.cod_distributore == -1) {
        info.cod_distributore = null;
      }
      if (info.cod_fornitore_switch == -1) {
        info.cod_fornitore_switch = null;
      }
      if (info.cod_type_misuratore == -1) {
        info.cod_type_misuratore = null;
      }
      if (info.cod_type_potenza == -1) {
        info.cod_type_potenza = null;
      }
      if (info.cod_type_state == -1) {
        info.cod_type_state = null;
      }
      if (info.cod_type_stima == -1) {
        info.cod_type_stima = null;
      }
      if (this.oldInfo != JSON.stringify(this.data.item.info)) {
        this.podsService.updateInfo(this.data.item.id, info).then((res) => {
          if (res.success) {
            delete res.item.id;
            this.data.item.info = res.item;
            this.data.item.info.sospendibile = Boolean(this.data.item.info.sospendibile)
          }
        });
      }
      this.oldInfo = null;
      this.isInEdit = !this.isInEdit;
    },

    onDeleteLettura(podId, letturaId) {
      this.loader = true;
      this.podsService
        .deleteLettura(podId, letturaId)
        .then((res) => {
          if (res.success) {
            this.getLetture();
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    getAutoletturaId(lettura) {
      const rawId = lettura?.id_autolettura;

      if (rawId === null || rawId === undefined || rawId === "") {
        return null;
      }

      const parsed = Number(rawId);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    },

    hasAutoletturaId(lettura) {
      return this.getAutoletturaId(lettura) !== null;
    },

    buildStoricoAutoletturaView(record) {
      const emptyView = { valori: [], date: [], utente: [], conferma: [], hasData: false };

      if (!record || typeof record !== "object") {
        return emptyView;
      }

      const valoriFields = [
        { key: "a1", label: "F1" },
        { key: "a2", label: "F2" },
        { key: "a3", label: "F3" },
        { key: "r1", label: "R1" },
        { key: "r2", label: "R2" },
        { key: "r3", label: "R3" },
        { key: "p1", label: "P1" },
        { key: "p2", label: "P2" },
        { key: "p3", label: "P3" },
        { key: "mq", label: "MQ" },
        { key: "coeff", label: "Coefficiente" },
      ];

      const dateFields = [
        { key: "data_autolettura", label: "Data autolettura" },
        { key: "date_conferma_autolettura", label: "Data conferma" },
        { key: "data_inserimento", label: "Data inserimento" },
        { key: "data_riferimento", label: "Data riferimento" },
      ];

      const hasValue = (value) =>
        value !== null && value !== undefined && value !== "";

      const formatStoricoDate = (value) => {
        const parsed = moment(value);
        return parsed.isValid() ? parsed.format("DD/MM/YYYY HH:mm") : value;
      };

      const formatStoricoNumber = (value) => {
        const parsed = Number(value);
        if (!Number.isFinite(parsed)) {
          return value;
        }

        return Number.isInteger(parsed)
          ? String(parsed)
          : parsed.toLocaleString("it-IT", { maximumFractionDigits: 3 });
      };

      const valori = valoriFields
        .filter(({ key }) => hasValue(record[key]))
        .map(({ key, label }) => ({
          key,
          label,
          value: formatStoricoNumber(record[key]),
        }));

      const date = dateFields
        .filter(({ key }) => hasValue(record[key]))
        .map(({ key, label }) => ({
          key,
          label,
          value: formatStoricoDate(record[key]),
        }));

      const utente = [];
      const emailValue = hasValue(record.email) ? String(record.email).trim() : "";

      if (emailValue) {
        utente.push({
          key: "tipo_inserimento",
          label: "Inserita da",
          value: "Utente esterno",
          tone: "external",
        });
        utente.push({
          key: "email",
          label: "Email",
          value: emailValue,
        });
      } else {
        utente.push({
          key: "tipo_inserimento",
          label: "Inserita da",
          value: "Utente interno",
          tone: "internal",
        });

        if (hasValue(record.user)) {
          utente.push({
            key: "user",
            label: "Utente",
            value: record.user,
          });
        }
      }

      const conferma = [
        {
          key: "confermata_da",
          label: "Confermata da",
          value: hasValue(record.user_id)
            ? hasValue(record.user)
              ? record.user
              : record.user_id
            : "Sistema",
          tone: hasValue(record.user_id) ? "internal" : "system",
        },
      ];

      return {
        valori,
        date,
        utente,
        conferma,
        hasData: valori.length + date.length + utente.length + conferma.length > 0,
      };
    },

    async openStoricoAutoletturaDialog(lettura) {
      this.storicoAutoletturaDialog = true;
      this.storicoAutoletturaLoading = false;
      this.storicoAutoletturaError = null;
      this.storicoAutoletturaData = null;

      const id = this.getAutoletturaId(lettura);

      if (!id) {
        this.storicoAutoletturaError = "ID autolettura non disponibile";
        return;
      }

      this.storicoAutoletturaLoading = true;

      try {
        const res = await this.autoLetturaService.getStoricoAutolettura(id);
        const payload = res?.data?.success !== undefined ? res.data : res;

        if (payload?.success && payload?.data) {
          this.storicoAutoletturaData = payload.data;
        } else {
          this.storicoAutoletturaError =
            payload?.message || "Impossibile recuperare lo storico autolettura";
        }
      } catch (error) {
        this.storicoAutoletturaError =
          error?.response?.data?.message ||
          "Errore durante il recupero dello storico autolettura";
      } finally {
        this.storicoAutoletturaLoading = false;
      }
    },

    closeStoricoAutoletturaDialog() {
      this.storicoAutoletturaDialog = false;
      this.storicoAutoletturaLoading = false;
      this.storicoAutoletturaError = null;
      this.storicoAutoletturaData = null;
    },

    onRiusaLettura(podId, letturaId) {
      this.loader = true;
      this.podsService
        .riusaLettura(podId, letturaId)
        .then((res) => {
          if (res.success) {
            this.getLetture();
          } else {
            alert(`Ci sono stati problemi durante l'aggiornamento`);
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    onRowEditLetturaComplete(evt) {
      let { data, newData } = evt;
      if (data.used == 0 && data.autolettura == 1) {
        this.loader = true;
        this.podsService
          .updateLettura({...newData, pod_id: this.data.item.id})
          .then((res) => {
            if (res.item) {
              this.getLetture();
              this.$toast.add({
                severity: "info",
                summary: "Successo",
                detail: "Lettura modificata",
                life: 3000,
              });
            }
          })
          .finally(() => {
            this.loader = false;
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Info",
          detail: "Lettura non modificabile",
          life: 3000,
        });
      }
    },

    viewAllLetture() {
      if (
        this.data.item &&
        "info" in this.data.item &&
        this.data.item.info.code
      ) {
        this.loader = true;
        this.utilityService
          .viewAllLetture(this.data.item.info.code, "pod")
          .then((res) => {
            this.allLettureDialog = true;
            this.allLetture = res.items;
            console.log(res);
          })
          .finally(() => {
            this.loader = false;
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Info",
          detail: "Dati non disponibili",
          life: 3000,
        });
      }
    },

    formatContrattoVenditaDataFine(contratto) {
      const dataFine = contratto?.data_fine;
      return dataFine ? moment(dataFine).format("DD/MM/YYYY") : "";
    },

    isContrattoVenditaDataFineEditable(contratto) {
      if (!contratto?.c_id) {
        return false;
      }

      const contrattoCorrenteId = Number(this.data.item.cod_contratto);
      if (contrattoCorrenteId > 0 && Number(contratto.c_id) === contrattoCorrenteId) {
        return false;
      }

      return true;
    },

    getContrattoVenditaApiErrorMessage(result) {
      if (result.message) {
        return result.message;
      }

      if (result.validate) {
        const messages = Object.values(result.validate).flat();
        if (messages.length) {
          return messages.join(" ");
        }
      }

      return "Impossibile aggiornare la data fine del contratto.";
    },

    onCellContrattoVenditaEditInit(event) {
      if (event.field !== "data_fine") {
        return;
      }

      if (!this.isContrattoVenditaDataFineEditable(event.data)) {
        return;
      }

      const dataFine = event.data.data_fine;
      event.data._originalDataFine = dataFine
        ? moment(dataFine).format("YYYY-MM-DD")
        : null;

      if (dataFine) {
        const parsedDate = moment(dataFine).toDate();
        event.data._editDataFine = !isNaN(parsedDate.valueOf())
          ? parsedDate
          : null;
      } else {
        event.data._editDataFine = null;
      }
    },

    async confirmContrattoVenditaDataFine(contratto, editorCancelCallback) {
      if (!this.isContrattoVenditaDataFineEditable(contratto)) {
        return;
      }

      if (!contratto._editDataFine) {
        this.$toast.add({
          severity: "warn",
          summary: "Data mancante",
          detail: "Seleziona una data fine valida.",
          life: 3000,
        });
        return;
      }

      const nuovaDataFine = moment(contratto._editDataFine).format("YYYY-MM-DD");

      if (
        contratto._originalDataFine &&
        nuovaDataFine === contratto._originalDataFine
      ) {
        if (typeof editorCancelCallback === "function") {
          editorCancelCallback();
        }
        return;
      }

      if (typeof editorCancelCallback === "function") {
        editorCancelCallback();
      }

      this.loader = true;

      try {
        const result = await this.podsService.changeDataFineContrattoVendita(
          this.data.item.id,
          contratto.c_id,
          nuovaDataFine
        );

        if (result.success) {
          await this.getDettaglioPod(this.data.item.id);
          this.$toast.add({
            severity: "success",
            summary: "Successo",
            detail: "Data fine contratto aggiornata",
            life: 3000,
          });
        } else {
          await this.getDettaglioPod(this.data.item.id);
          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail: this.getContrattoVenditaApiErrorMessage(result),
            life: 5000,
          });
        }
      } finally {
        delete contratto._editDataFine;
        delete contratto._originalDataFine;
        this.loader = false;
      }
    },

    onCellRcusDateEditComplete(event) {
      this.loader = true;
      let obj = { ...event.newData };
      obj[event.field] = moment(event.newValue).format("YYYY-MM-DD");
      obj.fornitura_id = this.data.item.id;
      this.utilityService
        .updateDateRcu(obj, "pod")
        .then((res) => {
          if (res.item == 1) {
            this.getDettaglioPod(this.data.item.id);
            this.$toast.add({
              severity: "info",
              summary: "Successo",
              detail: "Data modificata",
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    onDeleteMensilitaReale(podId, mensilitaId) {
      this.podsService.deleteMensilitaReale(podId, mensilitaId).then((res) => {
        if (res.success) {
          this.getMensilitaReali();
        }
      });
    },

    onDeleteFatturaVoce(voce) {
      this.utilityService.onDeleteFatturaVoce(voce.id, "pod").then((res) => {
        if (res && res.success) {
          this.getDettaglioPod(this.data.item.id);
        } else if (
          res &&
          res.message &&
          res.message.includes("Impossibile eliminare: la voce è in uso")
        ) {
          this.$toast.add({
            severity: "warn",
            summary: "Attenzione",
            detail: "voce già in uso",
            life: 3000,
          });
        }
      });
    },

    onVoltura() {
      alert("Voltura");
    },

    onAggiornaConsumi() {
      this.getConsumo(this.data.item.id);
    },

    openFatturaVociDialog() {
      this.reportInsertFatturaVoci = [];
      this.submitted = false;
      this.fatturaVociDialog = true;
    },

    onCambiaOfferta() {
      const ids = [this.route.params.id];
      this.$eventBus.emit("show-dialog-page", {
        page: "pods-cambia-offerta",
        title: "Cambia Offerta Pods",
        data: ids,
        buttonOk: {
          label: "Chiudi",
          icon: "pi pi-times",
          class: "p-button-text",
          visible: true,
          disabled: false,
        },
        buttonCancel: {
          label: "",
          icon: "",
          class: "",
          visible: false,
          disabled: false,
        },
      });
    },

    validateFormFatturaVoce() {
      this.validationErrors = {};
      if (this.newFatturavoce.voce && this.newFatturavoce.voce != "")
        delete this.validationErrors["voce"];
      else this.validationErrors["voce"] = true;
      if (this.newFatturavoce.importo && this.newFatturavoce.importo != "")
        delete this.validationErrors["importo"];
      else this.validationErrors["importo"] = true;
      if (this.newFatturavoce.aliquota && this.newFatturavoce.aliquota != "")
        delete this.validationErrors["aliquota"];
      else this.validationErrors["aliquota"] = true;
      if (
        this.newFatturavoce.descrizione &&
        this.newFatturavoce.descrizione != ""
      )
        delete this.validationErrors["descrizione"];
      else this.validationErrors["descrizione"] = true;
      if (this.newFatturavoce.periodo) delete this.validationErrors["periodo"];
      else this.validationErrors["periodo"] = true;
      return !Object.keys(this.validationErrors).length;
    },

    validateNewLettura() {
      this.validationErrors = {};
      if (parseFloat(this.letturaNew.eaf1) >= 0)
        delete this.validationErrors["eaf1"];
      else this.validationErrors["eaf1"] = true;
      if (parseFloat(this.letturaNew.eaf2) >= 0)
        delete this.validationErrors["eaf2"];
      else this.validationErrors["eaf2"] = true;
      if (parseFloat(this.letturaNew.eaf3) >= 0)
        delete this.validationErrors["eaf3"];
      else this.validationErrors["eaf3"] = true;
      if (parseFloat(this.letturaNew.erf1) >= 0)
        delete this.validationErrors["erf1"];
      else this.validationErrors["erf1"] = true;
      if (parseFloat(this.letturaNew.erf2) >= 0)
        delete this.validationErrors["erf2"];
      else this.validationErrors["erf2"] = true;
      if (parseFloat(this.letturaNew.erf3) >= 0)
        delete this.validationErrors["erf3"];
      else this.validationErrors["erf3"] = true;
      if (parseFloat(this.letturaNew.pf1) >= 0)
        delete this.validationErrors["pf1"];
      else this.validationErrors["pf1"] = true;
      if (parseFloat(this.letturaNew.pf2) >= 0)
        delete this.validationErrors["pf2"];
      else this.validationErrors["pf2"] = true;
      if (parseFloat(this.letturaNew.pf3) >= 0)
        delete this.validationErrors["pf3"];
      else this.validationErrors["pf3"] = true;
      return !Object.keys(this.validationErrors).length;
    },

    exportCSV() {
      this.$refs.all_letture.exportCSV();
    },

    openConsumoDialog() {
      this.consumoDialog = true;
    },

    async addConsumo() {
      this.loader = true;
      const podCode = this.data.item.info.code;

      try {
        if (this.newConsumo.data_comunicazione) {
          this.newConsumo.data_comunicazione = moment(
            this.newConsumo.data_comunicazione
          ).format("YYYY-MM");
        }
        if (this.newConsumo.data_misura) {
          this.newConsumo.data_misura = moment(
            this.newConsumo.data_misura
          ).format("YYYY-MM");
        }

        const response = await this.utilityService.addConsumo({
          ...this.newConsumo,
          pod: podCode,
          saveconsumo: true,
        });

        if (response.success) {
          this.$toast.add({
            severity: "success",
            summary: "Successo",
            detail: response.message,
            life: 3000,
          });

          this.data.item.consumi_distributore.push({
            ...this.newConsumo,
            data_comunicazione: moment(
              this.newConsumo.data_comunicazione,
              "YYYY-MM"
            )
              .format("MMMM YYYY")
              .toUpperCase(),
            data_misura: moment(this.newConsumo.data_misura, "YYYY-MM")
              .format("MMMM YYYY")
              .toUpperCase(),
          });

          this.newConsumo = {
            data_comunicazione: null,
            data_misura: null,
            eaf1: 0,
            eaf2: 0,
            eaf3: 0,
            pf1: 0,
            pf2: 0,
            pf3: 0,
            erf1: 0,
            erf2: 0,
            erf3: 0,
            type: "C",
          };

          this.consumoDialog = false;
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Errore durante l'aggiunta del consumo",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error occurred:", error);
        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante l'aggiunta del consumo",
          life: 3000,
        });
      } finally {
        this.loader = false;
      }
    },

    async getConsumo(podId) {
      this.loader = true;
      try {
        const response = await this.utilityService.getConsumo({ podId: podId });

        const moment = require("moment");

        this.consumi = [];

        if (response.success && response.items) {
          console.log('consumi', response.items);

          const consumiPerMese = {};

          response.items.forEach(item => {
            const key = moment(item.data_misura).format("YYYY-MM");
            const currentItem = consumiPerMese[key];

            if (
              !currentItem ||
              moment(item.data_comunicazione).isAfter(moment(currentItem.data_comunicazione))
            ) {
              consumiPerMese[key] = item;
            }
          });
          
          this.consumi = Object.values(consumiPerMese).map((item) => ({
            ...item,
            data_comunicazione: item.data_comunicazione
              ? moment(item.data_comunicazione)
                  .locale("it")
                  .format("D MMMM YYYY HH:mm")
                  .toUpperCase()
              : "",
            data_misura: item.data_misura
              ? moment(item.data_misura, "YYYY-MM-DD")
                  .locale("it")
                  .format("MMMM YYYY")
                  .toUpperCase()
              : "",
          }));
          this.consumiKey += 1;
        }
      } catch (error) {
        console.error("Errore nel recupero dei dati del consumo:", error);
      } finally {
        this.loader = false;
      }
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    },

    isRapidChecked(row) {
      return Number(row?.rapidCheck) === 1;
    },

    formatRapidCheckDate(date) {
      return date ? moment(date).format('DD/MM/YYYY HH:mm') : '';
    },

    applyRapidCheckToRow(rowId, dataRapidCheck) {
      const mensilita = this.data.item.mensilita_fatturabili || [];
      const target = mensilita.find((item) => Number(item.id) === Number(rowId));
      if (!target) {
        return;
      }
      target.rapidCheck = 1;
      target.data_rapidCheck = dataRapidCheck;
    },

    async onRapidCheck(row) {
      if (!row?.id || !row.cod_pod || !row.mese || !row.fine || this.isRapidChecked(row) || this.rapidCheckLoadingId === row.id) {
        return;
      }

      this.rapidCheckLoadingId = row.id;

      try {
        const result = await this.podsService.setRapidCheckFatturabile(row);

        if (result.success) {
          this.applyRapidCheckToRow(
            result.data?.id || row.id,
            result.data?.data_rapidCheck || moment().format('YYYY-MM-DD HH:mm:ss')
          );
          this.$toast.add({
            severity: 'success',
            summary: 'Richiesta Conguaglio',
            detail: 'Richiesta conguaglio salvata',
            life: 2500,
          });
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Impossibile salvare il check rapido',
            life: 3000,
          });
        }
      } catch (error) {
        console.error('Errore Check Rapido:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile salvare il check rapido',
          life: 3000,
        });
      } finally {
        this.rapidCheckLoadingId = null;
      }
    },

    onMensilitaFatturabileCellEditInit(event) {
      const row = event?.data;
      if (!row) {
        return;
      }
      if (row._originalInizio === undefined) {
        row._originalInizio = row.inizio ?? null;
      }
      if (row._originalFine === undefined) {
        row._originalFine = row.fine ?? null;
      }
    },

    formatFatturabileApiDate(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }
      const parsed = moment(value);
      return parsed.isValid() ? parsed.format("YYYY-MM-DD") : value;
    },

    restoreMensilitaFatturabileDates(row, originals) {
      if (!row || !originals) {
        return;
      }
      row.inizio = originals.inizio;
      row.fine = originals.fine;
    },

    clearMensilitaFatturabileOriginals(row) {
      if (!row) {
        return;
      }
      delete row._originalInizio;
      delete row._originalFine;
    },

    async confirmEdit(data, field, cancelCallback) {
      const originals = {
        inizio: data?._originalInizio !== undefined ? data._originalInizio : data?.inizio,
        fine: data?._originalFine !== undefined ? data._originalFine : data?.fine,
      };
      const payload = {
        ...data,
        inizio: this.formatFatturabileApiDate(data?.inizio),
        fine: this.formatFatturabileApiDate(data?.fine),
      };
      const target = (this.data.item.mensilita_fatturabili || []).find(
        (item) => Number(item.id) === Number(data?.id)
      );

      try {
        if (typeof cancelCallback === "function") {
          cancelCallback();
        }

        const result = await this.podsService.updateMensilitaFatturabile(payload);

        if (result.success) {
          if (target) {
            target.inizio = payload.inizio;
            target.fine = payload.fine;
          }
          this.clearMensilitaFatturabileOriginals(target || data);
          this.$toast.add({
            severity: "success",
            summary: "Aggiornamento riuscito",
            detail: "Le date sono state aggiornate con successo",
            life: 3000,
          });
          this.mensilitaFatturabiliKey += 1;
        } else {
          this.restoreMensilitaFatturabileDates(target, originals);
          this.restoreMensilitaFatturabileDates(data, originals);
          this.clearMensilitaFatturabileOriginals(target || data);
          this.mensilitaFatturabiliKey += 1;
          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Impossibile aggiornare le date",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Errore durante l'aggiornamento:", error);
        this.restoreMensilitaFatturabileDates(target, originals);
        this.restoreMensilitaFatturabileDates(data, originals);
        this.clearMensilitaFatturabileOriginals(target || data);
        this.mensilitaFatturabiliKey += 1;
        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Si è verificato un errore durante l'aggiornamento",
          life: 3000,
        });
      }
    },
    
    onDateSelect(event, rowData, field) {
      const selectedDate = moment(event).format('YYYY-MM-DD');
      rowData[field] = selectedDate;
    },
    
    async getMensilitaFatturabili() {
      try {
        this.loader = true;
        
        const podId = this.dettaglioPod.id;
        

        const result = await this.podsService.getMensilitaFatturabili(podId);
        
        if (result && result.items) {
          this.mensilitaFatturabili = result.items.map(item => {
            return {
              ...item,
              inizio: item.inizio || null,
              fine: item.fine || null
            };
          });
          
          this.mensilitaFatturabiliKey += 1;
        }
      } catch (error) {
        console.error('Errore nel recupero delle mensilità fatturabili:', error);
      } finally {
        this.loader = false;
      }
    },
    getFirstDayOfMonth(dateString) {
      if (!dateString) return null;
      
      const date = moment(dateString);
      return date.clone().startOf('month').toDate();
    },
    getLastDayOfMonth(dateString) {
      if (!dateString) return null;
      
      const date = moment(dateString);
      return date.clone().endOf('month').toDate();
    },
    canRiusaMensilitaReale(row) {
      const usedFt = row?.used_ft;
      return usedFt == null || String(usedFt).trim() === "";
    },
    isRiusaMensilitaRealeDisabled(row) {
      return (
        Number(row?.used) === 0 ||
        this.riusandoMensilitaIds.includes(Number(row?.id))
      );
    },
    onMensilitaRealeUsed2(podId, mensilitaId) {
      this.podsService.mensilitaRealeUsed2(podId, mensilitaId).then((res) => {
        if (res.success) {
          this.getMensilitaReali();
        }
      });
    },
    onRiusaMensilitaReale(podId, mensilitaId) {
      const rows = this.data.item.mesilita_reali || [];
      const row = rows.find((item) => Number(item.id) === Number(mensilitaId));
      if (!row || this.isRiusaMensilitaRealeDisabled(row)) {
        return;
      }

      this.riusandoMensilitaIds.push(Number(mensilitaId));
      this.podsService.riusaMensilitaReale(podId, mensilitaId).then((res) => {
        if (res.success) {
          row.used = 0;
          this.getMensilitaReali();
          this.$toast.add({
            severity: "info",
            summary: "Successo",
            detail: "Mensilità reale riutilizzabile",
            life: 3000,
          });
        } else {
          this.riusandoMensilitaIds = this.riusandoMensilitaIds.filter(
            (id) => id !== Number(mensilitaId)
          );
          this.$toast.add({
            severity: "warn",
            summary: "Attenzione",
            detail: "Impossibile riusare la mensilità reale",
            life: 3000,
          });
        }
      });
    },
  },

  computed: {
    storicoAutoletturaView() {
      return this.buildStoricoAutoletturaView(this.storicoAutoletturaData);
    },

    dataInizio: {
      get: function () {
        const info = this.data?.item?.info;
        if (!info) {
          return null;
        }

        return info.data_inizio !== null &&
          info.data_inizio !== ""
          ? moment(info.data_inizio).toDate()
          : null;
      },
      set: function (value) {
        const info = this.data?.item?.info;
        if (!info) {
          return;
        }

        if (value instanceof Date && !isNaN(value.valueOf())) {
          info.data_inizio = moment(value).format("YYYY-MM-DD");
        }
        if (value === null || value === "") {
          info.data_inizio = null;
        }
      },
    },
    dataFine: {
      get: function () {
        const info = this.data?.item?.info;
        if (!info) {
          return null;
        }

        return info.data_fine !== null &&
          info.data_fine !== ""
          ? moment(info.data_fine).toDate()
          : null;
      },
      set: function (value) {
        const info = this.data?.item?.info;
        if (!info) {
          return;
        }

        if (value instanceof Date && !isNaN(value.valueOf())) {
          info.data_fine = moment(value).format("YYYY-MM-DD");
        }
        if (value === null || value === "") {
          info.data_fine = null;
        }
      },
    },
    fatture_ordinate: function () {
      const fatture = this.data.item.fatture?.dettagli || [];
      // Prima quelle da pagare, poi le pagate; dentro ogni gruppo resta l'ordine del backend
      return [
        ...fatture.filter((el) => this.isFatturaDaPagare(el)),
        ...fatture.filter((el) => !this.isFatturaDaPagare(el)),
      ];
    },
    hasWizardCaricamentiAccess() {
      try {
        const encodedUser =
          this.store?.state?.auth?.user || localStorage.getItem("user");

        if (!encodedUser) {
          return false;
        }

        const decodedUser = JSON.parse(atob(encodedUser));
        const profile = decodedUser?.user?.[0]?.profile;

        if (!profile) {
          return false;
        }

        return profile.name === "all" || profile.all === 1;
      } catch (error) {
        console.error("Errore nel controllo del profilo utente:", error);
        return false;
      }
    },
  },

  setup() {
    const router = useRouter();
    const store = useStore();

    return {
      router,
      store,
    };
  }
};
</script>

<style>
.mensilita-edit-hint {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0 0 0.75rem;
  color: #475569;
  font-size: 0.85rem;
}
.mensilita-edit-hint .pi-pencil {
  color: #1e3a8a;
  font-size: 0.8rem;
}
.editable-date-cell {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.15rem 0.35rem 0.15rem 0;
  border-bottom: 1px dashed #64748b;
  color: #1e3a8a;
  cursor: pointer;
}
.editable-date-cell .pi-pencil {
  font-size: 0.72rem;
  opacity: 0.75;
}
.editable-date-cell:hover {
  border-bottom-color: #1e3a8a;
}
.editable-date-cell:hover .pi-pencil {
  opacity: 1;
}
.p-datatable .p-datatable-tbody > tr.fattura-da-pagare {
  background-color: #fef2f2;
}

.p-datatable .p-datatable-tbody > tr.fattura-da-pagare > td:first-child {
  border-left: 4px solid #ef4444;
}

.preview-fattura-accordion {
  margin-bottom: 1rem;
}

.preview-fattura-accordion__title {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
}

.preview-fattura-accordion__icon {
  color: #b45309;
}

.preview-fattura-accordion .p-accordion-header-link {
  background: linear-gradient(90deg, #fff7ed 0%, #ffedd5 100%) !important;
  border: 1px solid #fdba74 !important;
  border-left: 4px solid #f97316 !important;
  color: #9a3412 !important;
}

.preview-fattura-accordion .p-accordion-header-link:hover {
  background: linear-gradient(90deg, #ffedd5 0%, #fed7aa 100%) !important;
}

.preview-fattura-accordion .p-accordion-tab-active .p-accordion-header-link {
  background: linear-gradient(90deg, #ffedd5 0%, #fdba74 100%) !important;
}

.preview-fattura-accordion .p-accordion-content {
  border: 1px solid #fdba74 !important;
  border-top: none !important;
  background-color: #fffaf5 !important;
}

.storico-autolettura-content {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}

.storico-autolettura-state {
  align-items: center;
  color: var(--text-color-secondary);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  justify-content: center;
  min-height: 140px;
  padding: 1.5rem 1rem;
  text-align: center;
}

.storico-autolettura-state p {
  margin: 0;
}

.storico-autolettura-state--empty i {
  font-size: 1.75rem;
  opacity: 0.45;
}

.storico-autolettura-alert {
  align-items: flex-start;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  color: #b91c1c;
  display: flex;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
}

.storico-autolettura-alert i {
  font-size: 1.1rem;
  margin-top: 0.1rem;
}

.storico-section {
  background: var(--surface-ground);
  border: 1px solid var(--surface-border);
  border-radius: 10px;
  overflow: hidden;
}

.storico-section-title {
  align-items: center;
  background: var(--surface-card);
  border-bottom: 1px solid var(--surface-border);
  color: var(--text-color);
  display: flex;
  font-size: 0.82rem;
  font-weight: 700;
  gap: 0.5rem;
  letter-spacing: 0.04em;
  margin: 0;
  padding: 0.7rem 0.9rem;
  text-transform: uppercase;
}

.storico-section-title i {
  color: var(--primary-color);
}

.storico-values-grid {
  display: grid;
  gap: 0.65rem;
  grid-template-columns: repeat(auto-fill, minmax(88px, 1fr));
  padding: 0.85rem;
}

.storico-value-card {
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-height: 68px;
  padding: 0.55rem 0.6rem;
}

.storico-value-label {
  color: var(--text-color-secondary);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.storico-value-number {
  color: var(--text-color);
  font-size: 1rem;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.storico-info-list {
  display: flex;
  flex-direction: column;
}

.storico-info-row {
  align-items: center;
  border-bottom: 1px solid var(--surface-border);
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 0.7rem 0.9rem;
}

.storico-info-row:last-child {
  border-bottom: none;
}

.storico-info-label {
  color: var(--text-color-secondary);
  font-size: 0.85rem;
  font-weight: 600;
}

.storico-info-value {
  color: var(--text-color);
  font-size: 0.92rem;
  font-weight: 600;
  text-align: right;
}

.storico-info-value--external {
  color: #0d9488;
}

.storico-info-value--internal {
  color: #2563eb;
}

.storico-info-value--system {
  color: var(--text-color-secondary);
  font-style: italic;
}

.text-muted {
  color: var(--text-color-secondary);
}

.wizard-log-json {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 0.85rem;
  line-height: 1.4;
}
</style>
